/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * CloudQuery OpenAPI Spec
 * Welcome to the CloudQuery API documentation! This API can be used to interact with the CloudQuery platform. The API allows you to manage your teams, usage, spend limits, plugins, addons, cloud syncs, and much more.

The API is secured using bearer tokens. To get started, you can generate an API key from the CloudQuery dashboard. For a step-by-step guide, see: https://www.cloudquery.io/docs/cli/managing-cloudquery/deployments/generate-api-key.

The base URL for the API is `https://api.cloudquery.io`.

 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AIOnboardingChat200,
  AIOnboardingChatBody,
  AIOnboardingEndConversation200,
  AIOnboardingNewConversation200,
  AIOnboardingNewConversationBody,
  APIKey,
  AcceptTeamInvitationBody,
  ActivatePlatform200,
  ActivatePlatform205,
  ActivatePlatformBody,
  Addon,
  AddonAsset,
  AddonCreate,
  AddonOrder,
  AddonOrderCreate,
  AddonUpdate,
  AddonVersion,
  AddonVersionUpdate,
  AuthRegistryRequestParams,
  BadRequestResponse,
  CheckUserAuthStatus200,
  ConflictResponse,
  CreateAddonVersionBody,
  CreatePluginVersionBody,
  CreatePluginVersionDocs201,
  CreatePluginVersionDocsBody,
  CreatePluginVersionTables201,
  CreatePluginVersionTablesBody,
  CreateTeamAPIKeyBody,
  CreateTeamBody,
  CreateTeamImages201,
  CreateTeamImagesBody,
  CreateUserToken201,
  DeletePluginVersionDocsBody,
  DeletePluginVersionTablesBody,
  DeleteTeamInvitationBody,
  DeterminePlatformTenantByEmail200,
  DeterminePlatformTenantByEmailParams,
  DockerErrorResponse,
  EmailTeamInvitationBody,
  FinalizePluginUIAssetUploadBody,
  ForbiddenResponse,
  GetCurrentUserMemberships200,
  GetCurrentUserMembershipsParams,
  GetGroupedTeamUsageSummaryParams,
  GetManagedDatabases200,
  GetManagedDatabasesParams,
  GetOpenAPIJSON200,
  GetPluginNotificationRequest200,
  GetTeamMemberships200,
  GetTeamMembershipsParams,
  GetTeamUsageSummaryParams,
  ImageURL,
  InternalErrorResponse,
  Invitation,
  ListAddon,
  ListAddonOrdersByTeam200,
  ListAddonOrdersByTeamParams,
  ListAddonVersions200,
  ListAddonVersionsParams,
  ListAddons200,
  ListAddonsByTeam200,
  ListAddonsByTeamParams,
  ListAddonsParams,
  ListCurrentUserInvitations200,
  ListCurrentUserInvitationsParams,
  ListInvoicesByTeam200,
  ListInvoicesByTeamParams,
  ListPlugin,
  ListPluginNotificationRequests200,
  ListPluginNotificationRequestsParams,
  ListPluginUpcomingPriceChanges200,
  ListPluginVersionDocs200,
  ListPluginVersionDocsParams,
  ListPluginVersionTables200,
  ListPluginVersionTablesParams,
  ListPluginVersions200,
  ListPluginVersionsParams,
  ListPlugins200,
  ListPluginsByTeam200,
  ListPluginsByTeamParams,
  ListPluginsParams,
  ListSubscriptionOrdersByTeam200,
  ListSubscriptionOrdersByTeamParams,
  ListTeamAPIKeys200,
  ListTeamAPIKeysParams,
  ListTeamInvitations200,
  ListTeamInvitationsParams,
  ListTeamPluginUsage200,
  ListTeamPluginUsageParams,
  ListTeams200,
  ListTeamsParams,
  ListUsersByTeam200,
  ListUsersByTeamParams,
  LoginUserBody,
  ManagedDatabase,
  ManagedDatabaseCreate,
  MembershipWithTeam,
  MethodNotAllowedResponse,
  NotFoundResponse,
  Plugin,
  PluginAsset,
  PluginCreate,
  PluginNotificationRequest,
  PluginNotificationRequestCreate,
  PluginPrice,
  PluginPriceCreate,
  PluginTableDetails,
  PluginUpdate,
  PluginVersion,
  PluginVersionDetails,
  PluginVersionUpdate,
  RegisterUser201,
  RegisterUserBody,
  RegistryAuthToken,
  ReleaseURL,
  RemoveTeamMembershipBody,
  RenewPlatformActivation200,
  RenewPlatformActivation205,
  RenewPlatformActivationBody,
  ReplacePluginVersionDocs201,
  ReplacePluginVersionDocsBody,
  ReportPlatformDataBody,
  ReportTenantPlatformDataBody,
  RequiresAuthenticationResponse,
  ResetUserPasswordBody,
  SendAnonymousEventBody,
  SendUserEventBody,
  ServiceUnavailableResponse,
  Settings,
  SettingsUpdate,
  Team,
  TeamSubscriptionOrder,
  TeamSubscriptionOrderCreate,
  TooManyRequestsResponse,
  UnprocessableEntityResponse,
  UpdateCurrentUserBody,
  UpdateCustomerBody,
  UpdateTeamBody,
  UploadImageBody,
  UploadPluginUIAssets201,
  UploadPluginUIAssetsBody,
  UsageCurrent,
  UsageIncrease,
  UsageSummary,
  User,
  UserTOTPSetup200,
  UserTOTPVerify201,
  UserTOTPVerifyBody,
  VerifyUserEmailBody
} from './models';

import { customFetch } from '../../../custom-fetch/src/customFetch';
type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Health check endpoint, returns 200
 */
export const getHealthCheckUrl = () => {




  return `/`
}

export const healthCheck = async ( options?: RequestInit) => {

  return customFetch<void>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = unknown



export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Returns the OpenAPI definition in JSON format.
 * @summary Get OpenAPI JSON
 */
export const getGetOpenAPIJSONUrl = () => {




  return `/openapi.json`
}

export const getOpenAPIJSON = async ( options?: RequestInit) => {

  return customFetch<GetOpenAPIJSON200>(getGetOpenAPIJSONUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOpenAPIJSONQueryKey = () => {
    return [
    `/openapi.json`
    ] as const;
    }


export const getGetOpenAPIJSONQueryOptions = <TData = Awaited<ReturnType<typeof getOpenAPIJSON>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpenAPIJSON>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenAPIJSONQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenAPIJSON>>> = ({ signal }) => getOpenAPIJSON({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpenAPIJSON>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpenAPIJSONQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenAPIJSON>>>
export type GetOpenAPIJSONQueryError = unknown


/**
 * @summary Get OpenAPI JSON
 */

export function useGetOpenAPIJSON<TData = Awaited<ReturnType<typeof getOpenAPIJSON>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOpenAPIJSON>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOpenAPIJSONQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Health check endpoint, returns 200
 */
export const getCQHealthCheckUrl = () => {




  return `/cq-healthcheck`
}

export const cQHealthCheck = async ( options?: RequestInit) => {

  return customFetch<void>(getCQHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCQHealthCheckQueryKey = () => {
    return [
    `/cq-healthcheck`
    ] as const;
    }


export const getCQHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof cQHealthCheck>>, TError = InternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof cQHealthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCQHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof cQHealthCheck>>> = ({ signal }) => cQHealthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof cQHealthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type CQHealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof cQHealthCheck>>>
export type CQHealthCheckQueryError = InternalErrorResponse



export function useCQHealthCheck<TData = Awaited<ReturnType<typeof cQHealthCheck>>, TError = InternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof cQHealthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCQHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a URL to upload image that will be publicly accessible
 */
export const getUploadImageUrl = () => {




  return `/upload/image`
}

export const uploadImage = async (uploadImageBody: UploadImageBody, options?: RequestInit) => {

  return customFetch<ImageURL>(getUploadImageUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      uploadImageBody,)
  }
);}




export const getUploadImageMutationOptions = <TError = InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext> => {

const mutationKey = ['uploadImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadImage>>, {data: UploadImageBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadImage(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadImageMutationResult = NonNullable<Awaited<ReturnType<typeof uploadImage>>>
    export type UploadImageMutationBody = UploadImageBody
    export type UploadImageMutationError = InternalErrorResponse

    export const useUploadImage = <TError = InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadImage>>, TError,{data: UploadImageBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadImage>>,
        TError,
        {data: UploadImageBody},
        TContext
      > => {
      return useMutation(getUploadImageMutationOptions(options));
    }

/**
 * List all plugin notification requests
 */
export const getListPluginNotificationRequestsUrl = (params?: ListPluginNotificationRequestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugin-notification-requests?${stringifiedParams}` : `/plugin-notification-requests`
}

export const listPluginNotificationRequests = async (params?: ListPluginNotificationRequestsParams, options?: RequestInit) => {

  return customFetch<ListPluginNotificationRequests200>(getListPluginNotificationRequestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPluginNotificationRequestsQueryKey = (params?: ListPluginNotificationRequestsParams,) => {
    return [
    `/plugin-notification-requests`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPluginNotificationRequestsQueryOptions = <TData = Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(params?: ListPluginNotificationRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginNotificationRequestsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginNotificationRequests>>> = ({ signal }) => listPluginNotificationRequests(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginNotificationRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginNotificationRequests>>>
export type ListPluginNotificationRequestsQueryError = RequiresAuthenticationResponse | InternalErrorResponse



export function useListPluginNotificationRequests<TData = Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(
 params?: ListPluginNotificationRequestsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginNotificationRequests>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginNotificationRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a new plugin notification request.
 */
export const getCreatePluginNotificationRequestUrl = () => {




  return `/plugin-notification-requests`
}

export const createPluginNotificationRequest = async (pluginNotificationRequestCreate: PluginNotificationRequestCreate, options?: RequestInit) => {

  return customFetch<PluginNotificationRequest>(getCreatePluginNotificationRequestUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pluginNotificationRequestCreate,)
  }
);}




export const getCreatePluginNotificationRequestMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginNotificationRequest>>, TError,{data: PluginNotificationRequestCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPluginNotificationRequest>>, TError,{data: PluginNotificationRequestCreate}, TContext> => {

const mutationKey = ['createPluginNotificationRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginNotificationRequest>>, {data: PluginNotificationRequestCreate}> = (props) => {
          const {data} = props ?? {};

          return  createPluginNotificationRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginNotificationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginNotificationRequest>>>
    export type CreatePluginNotificationRequestMutationBody = PluginNotificationRequestCreate
    export type CreatePluginNotificationRequestMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreatePluginNotificationRequest = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginNotificationRequest>>, TError,{data: PluginNotificationRequestCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginNotificationRequest>>,
        TError,
        {data: PluginNotificationRequestCreate},
        TContext
      > => {
      return useMutation(getCreatePluginNotificationRequestMutationOptions(options));
    }

/**
 * Query plugin notification request for a given plugin.
 */
export const getGetPluginNotificationRequestUrl = (pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugin-notification-requests/${pluginTeam}/${pluginKind}/${pluginName}`
}

export const getPluginNotificationRequest = async (pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<GetPluginNotificationRequest200>(getGetPluginNotificationRequestUrl(pluginTeam,pluginKind,pluginName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPluginNotificationRequestQueryKey = (pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [
    `/plugin-notification-requests/${pluginTeam}/${pluginKind}/${pluginName}`
    ] as const;
    }


export const getGetPluginNotificationRequestQueryOptions = <TData = Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginNotificationRequestQueryKey(pluginTeam,pluginKind,pluginName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginNotificationRequest>>> = ({ signal }) => getPluginNotificationRequest(pluginTeam,pluginKind,pluginName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(pluginTeam && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginNotificationRequestQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginNotificationRequest>>>
export type GetPluginNotificationRequestQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetPluginNotificationRequest<TData = Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginNotificationRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginNotificationRequestQueryOptions(pluginTeam,pluginKind,pluginName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Remove plugin notification request for a given plugin.
 */
export const getDeletePluginNotificationRequestUrl = (pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugin-notification-requests/${pluginTeam}/${pluginKind}/${pluginName}`
}

export const deletePluginNotificationRequest = async (pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<void>(getDeletePluginNotificationRequestUrl(pluginTeam,pluginKind,pluginName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePluginNotificationRequestMutationOptions = <TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginNotificationRequest>>, TError,{pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginNotificationRequest>>, TError,{pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext> => {

const mutationKey = ['deletePluginNotificationRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginNotificationRequest>>, {pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}> = (props) => {
          const {pluginTeam,pluginKind,pluginName} = props ?? {};

          return  deletePluginNotificationRequest(pluginTeam,pluginKind,pluginName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginNotificationRequestMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginNotificationRequest>>>

    export type DeletePluginNotificationRequestMutationError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useDeletePluginNotificationRequest = <TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginNotificationRequest>>, TError,{pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginNotificationRequest>>,
        TError,
        {pluginTeam: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string},
        TContext
      > => {
      return useMutation(getDeletePluginNotificationRequestMutationOptions(options));
    }

/**
 * List all plugins
 */
export const getListPluginsUrl = (params?: ListPluginsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["include_release_stages","exclude_release_stages"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugins?${stringifiedParams}` : `/plugins`
}

export const listPlugins = async (params?: ListPluginsParams, options?: RequestInit) => {

  return customFetch<ListPlugins200>(getListPluginsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPluginsQueryKey = (params?: ListPluginsParams,) => {
    return [
    `/plugins`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPluginsQueryOptions = <TData = Awaited<ReturnType<typeof listPlugins>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(params?: ListPluginsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlugins>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlugins>>> = ({ signal }) => listPlugins(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlugins>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlugins>>>
export type ListPluginsQueryError = RequiresAuthenticationResponse | InternalErrorResponse



export function useListPlugins<TData = Awaited<ReturnType<typeof listPlugins>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(
 params?: ListPluginsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPlugins>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a plugin owned by the specified team. User must be part of that team.
 */
export const getCreatePluginUrl = () => {




  return `/plugins`
}

export const createPlugin = async (pluginCreate: PluginCreate, options?: RequestInit) => {

  return customFetch<Plugin>(getCreatePluginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pluginCreate,)
  }
);}




export const getCreatePluginMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlugin>>, TError,{data: PluginCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPlugin>>, TError,{data: PluginCreate}, TContext> => {

const mutationKey = ['createPlugin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPlugin>>, {data: PluginCreate}> = (props) => {
          const {data} = props ?? {};

          return  createPlugin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginMutationResult = NonNullable<Awaited<ReturnType<typeof createPlugin>>>
    export type CreatePluginMutationBody = PluginCreate
    export type CreatePluginMutationError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreatePlugin = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPlugin>>, TError,{data: PluginCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPlugin>>,
        TError,
        {data: PluginCreate},
        TContext
      > => {
      return useMutation(getCreatePluginMutationOptions(options));
    }

/**
 * Get details about a given plugin.
 */
export const getGetPluginUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}`
}

export const getPlugin = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<ListPlugin>(getGetPluginUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPluginQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}`
    ] as const;
    }


export const getGetPluginQueryOptions = <TData = Awaited<ReturnType<typeof getPlugin>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlugin>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginQueryKey(teamName,pluginKind,pluginName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlugin>>> = ({ signal }) => getPlugin(teamName,pluginKind,pluginName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlugin>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginQueryResult = NonNullable<Awaited<ReturnType<typeof getPlugin>>>
export type GetPluginQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetPlugin<TData = Awaited<ReturnType<typeof getPlugin>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlugin>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginQueryOptions(teamName,pluginKind,pluginName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update a plugin
 */
export const getUpdatePluginUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}`
}

export const updatePlugin = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    pluginUpdate: PluginUpdate, options?: RequestInit) => {

  return customFetch<Plugin>(getUpdatePluginUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pluginUpdate,)
  }
);}




export const getUpdatePluginMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate}, TContext> => {

const mutationKey = ['updatePlugin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlugin>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate}> = (props) => {
          const {teamName,pluginKind,pluginName,data} = props ?? {};

          return  updatePlugin(teamName,pluginKind,pluginName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePluginMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlugin>>>
    export type UpdatePluginMutationBody = PluginUpdate
    export type UpdatePluginMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdatePlugin = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlugin>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePlugin>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginUpdate},
        TContext
      > => {
      return useMutation(getUpdatePluginMutationOptions(options));
    }

/**
 * Delete plugin by team and plugin name
 */
export const getDeletePluginByTeamAndPluginNameUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}`
}

export const deletePluginByTeamAndPluginName = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<void>(getDeletePluginByTeamAndPluginNameUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePluginByTeamAndPluginNameMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext> => {

const mutationKey = ['deletePluginByTeamAndPluginName'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}> = (props) => {
          const {teamName,pluginKind,pluginName} = props ?? {};

          return  deletePluginByTeamAndPluginName(teamName,pluginKind,pluginName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginByTeamAndPluginNameMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>>

    export type DeletePluginByTeamAndPluginNameMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeletePluginByTeamAndPluginName = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginByTeamAndPluginName>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string},
        TContext
      > => {
      return useMutation(getDeletePluginByTeamAndPluginNameMutationOptions(options));
    }

/**
 * DEPRECATED. Plugin prices are now managed by category. This endpoint will be removed in the near future and currently returns only empty data.
 * @deprecated
 */
export const getListPluginUpcomingPriceChangesUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/upcoming-price-changes`
}

export const listPluginUpcomingPriceChanges = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<ListPluginUpcomingPriceChanges200>(getListPluginUpcomingPriceChangesUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPluginUpcomingPriceChangesQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/upcoming-price-changes`
    ] as const;
    }


export const getListPluginUpcomingPriceChangesQueryOptions = <TData = Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginUpcomingPriceChangesQueryKey(teamName,pluginKind,pluginName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>> = ({ signal }) => listPluginUpcomingPriceChanges(teamName,pluginKind,pluginName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginUpcomingPriceChangesQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>>
export type ListPluginUpcomingPriceChangesQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse


/**
 * @deprecated
 */

export function useListPluginUpcomingPriceChanges<TData = Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginUpcomingPriceChanges>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginUpcomingPriceChangesQueryOptions(teamName,pluginKind,pluginName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * DEPRECATED. Plugin prices are now managed by category. This endpoint will be removed in the near future and currently returns only empty data.
 * @deprecated
 */
export const getCreatePluginUpcomingPriceChangeUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/upcoming-price-changes`
}

export const createPluginUpcomingPriceChange = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    pluginPriceCreate: PluginPriceCreate, options?: RequestInit) => {

  return customFetch<PluginPrice>(getCreatePluginUpcomingPriceChangeUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pluginPriceCreate,)
  }
);}




export const getCreatePluginUpcomingPriceChangeMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate}, TContext> => {

const mutationKey = ['createPluginUpcomingPriceChange'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate}> = (props) => {
          const {teamName,pluginKind,pluginName,data} = props ?? {};

          return  createPluginUpcomingPriceChange(teamName,pluginKind,pluginName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginUpcomingPriceChangeMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>>
    export type CreatePluginUpcomingPriceChangeMutationBody = PluginPriceCreate
    export type CreatePluginUpcomingPriceChangeMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    /**
 * @deprecated
 */
export const useCreatePluginUpcomingPriceChange = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginUpcomingPriceChange>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;data: PluginPriceCreate},
        TContext
      > => {
      return useMutation(getCreatePluginUpcomingPriceChangeMutationOptions(options));
    }

/**
 * DEPRECATED. Plugin prices are now managed by category. This endpoint will be removed in the near future and currently returns only empty data.
 * @deprecated
 */
export const getDeletePluginUpcomingPriceChangesUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/upcoming-price-changes`
}

export const deletePluginUpcomingPriceChanges = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<void>(getDeletePluginUpcomingPriceChangesUrl(teamName,pluginKind,pluginName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePluginUpcomingPriceChangesMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext> => {

const mutationKey = ['deletePluginUpcomingPriceChanges'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}> = (props) => {
          const {teamName,pluginKind,pluginName} = props ?? {};

          return  deletePluginUpcomingPriceChanges(teamName,pluginKind,pluginName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginUpcomingPriceChangesMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>>

    export type DeletePluginUpcomingPriceChangesMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    /**
 * @deprecated
 */
export const useDeletePluginUpcomingPriceChanges = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginUpcomingPriceChanges>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string},
        TContext
      > => {
      return useMutation(getDeletePluginUpcomingPriceChangesMutationOptions(options));
    }

/**
 * List all versions for a given plugin
 */
export const getListPluginVersionsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugins/${teamName}/${pluginKind}/${pluginName}/versions?${stringifiedParams}` : `/plugins/${teamName}/${pluginKind}/${pluginName}/versions`
}

export const listPluginVersions = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams, options?: RequestInit) => {

  return customFetch<ListPluginVersions200>(getListPluginVersionsUrl(teamName,pluginKind,pluginName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPluginVersionsQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPluginVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listPluginVersions>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginVersionsQueryKey(teamName,pluginKind,pluginName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginVersions>>> = ({ signal }) => listPluginVersions(teamName,pluginKind,pluginName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginVersions>>>
export type ListPluginVersionsQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListPluginVersions<TData = Awaited<ReturnType<typeof listPluginVersions>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    params?: ListPluginVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginVersionsQueryOptions(teamName,pluginKind,pluginName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get details about a given plugin version.
 */
export const getGetPluginVersionUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`
}

export const getPluginVersion = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: RequestInit) => {

  return customFetch<PluginVersionDetails>(getGetPluginVersionUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPluginVersionQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`
    ] as const;
    }


export const getGetPluginVersionQueryOptions = <TData = Awaited<ReturnType<typeof getPluginVersion>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginVersionQueryKey(teamName,pluginKind,pluginName,versionName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginVersion>>> = ({ signal }) => getPluginVersion(teamName,pluginKind,pluginName,versionName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginVersion>>>
export type GetPluginVersionQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetPluginVersion<TData = Awaited<ReturnType<typeof getPluginVersion>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginVersionQueryOptions(teamName,pluginKind,pluginName,versionName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a new plugin version, or update a draft version
 */
export const getCreatePluginVersionUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`
}

export const createPluginVersion = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    createPluginVersionBody: CreatePluginVersionBody, options?: RequestInit) => {

  return customFetch<PluginVersion>(getCreatePluginVersionUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPluginVersionBody,)
  }
);}




export const getCreatePluginVersionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody}, TContext> => {

const mutationKey = ['createPluginVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginVersion>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  createPluginVersion(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginVersion>>>
    export type CreatePluginVersionMutationBody = CreatePluginVersionBody
    export type CreatePluginVersionMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useCreatePluginVersion = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginVersion>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionBody},
        TContext
      > => {
      return useMutation(getCreatePluginVersionMutationOptions(options));
    }

/**
 * Update a given plugin version
 */
export const getUpdatePluginVersionUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}`
}

export const updatePluginVersion = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    pluginVersionUpdate: PluginVersionUpdate, options?: RequestInit) => {

  return customFetch<PluginVersion>(getUpdatePluginVersionUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      pluginVersionUpdate,)
  }
);}




export const getUpdatePluginVersionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate}, TContext> => {

const mutationKey = ['updatePluginVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePluginVersion>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  updatePluginVersion(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePluginVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updatePluginVersion>>>
    export type UpdatePluginVersionMutationBody = PluginVersionUpdate
    export type UpdatePluginVersionMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdatePluginVersion = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePluginVersion>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePluginVersion>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: PluginVersionUpdate},
        TContext
      > => {
      return useMutation(getUpdatePluginVersionMutationOptions(options));
    }

/**
 * List all documentation pages for a given plugin version
 */
export const getListPluginVersionDocsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs?${stringifiedParams}` : `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`
}

export const listPluginVersionDocs = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams, options?: RequestInit) => {

  return customFetch<ListPluginVersionDocs200>(getListPluginVersionDocsUrl(teamName,pluginKind,pluginName,versionName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPluginVersionDocsQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPluginVersionDocsQueryOptions = <TData = Awaited<ReturnType<typeof listPluginVersionDocs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionDocs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginVersionDocsQueryKey(teamName,pluginKind,pluginName,versionName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginVersionDocs>>> = ({ signal }) => listPluginVersionDocs(teamName,pluginKind,pluginName,versionName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionDocs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginVersionDocsQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginVersionDocs>>>
export type ListPluginVersionDocsQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListPluginVersionDocs<TData = Awaited<ReturnType<typeof listPluginVersionDocs>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionDocsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionDocs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginVersionDocsQueryOptions(teamName,pluginKind,pluginName,versionName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create or update one or more plugin version docs pages
 */
export const getCreatePluginVersionDocsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`
}

export const createPluginVersionDocs = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    createPluginVersionDocsBody: CreatePluginVersionDocsBody, options?: RequestInit) => {

  return customFetch<CreatePluginVersionDocs201>(getCreatePluginVersionDocsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPluginVersionDocsBody,)
  }
);}




export const getCreatePluginVersionDocsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody}, TContext> => {

const mutationKey = ['createPluginVersionDocs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  createPluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginVersionDocs>>>
    export type CreatePluginVersionDocsMutationBody = CreatePluginVersionDocsBody
    export type CreatePluginVersionDocsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreatePluginVersionDocs = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionDocsBody},
        TContext
      > => {
      return useMutation(getCreatePluginVersionDocsMutationOptions(options));
    }

/**
 * Replace (override) multiple plugin version docs pages
 */
export const getReplacePluginVersionDocsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`
}

export const replacePluginVersionDocs = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    replacePluginVersionDocsBody: ReplacePluginVersionDocsBody, options?: RequestInit) => {

  return customFetch<ReplacePluginVersionDocs201>(getReplacePluginVersionDocsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      replacePluginVersionDocsBody,)
  }
);}




export const getReplacePluginVersionDocsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody}, TContext> => {

const mutationKey = ['replacePluginVersionDocs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replacePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  replacePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplacePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof replacePluginVersionDocs>>>
    export type ReplacePluginVersionDocsMutationBody = ReplacePluginVersionDocsBody
    export type ReplacePluginVersionDocsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useReplacePluginVersionDocs = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replacePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof replacePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: ReplacePluginVersionDocsBody},
        TContext
      > => {
      return useMutation(getReplacePluginVersionDocsMutationOptions(options));
    }

/**
 * Delete one or more plugin version docs pages.
 */
export const getDeletePluginVersionDocsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/docs`
}

export const deletePluginVersionDocs = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    deletePluginVersionDocsBody: DeletePluginVersionDocsBody, options?: RequestInit) => {

  return customFetch<void>(getDeletePluginVersionDocsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deletePluginVersionDocsBody,)
  }
);}




export const getDeletePluginVersionDocsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody}, TContext> => {

const mutationKey = ['deletePluginVersionDocs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginVersionDocs>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  deletePluginVersionDocs(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginVersionDocsMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginVersionDocs>>>
    export type DeletePluginVersionDocsMutationBody = DeletePluginVersionDocsBody
    export type DeletePluginVersionDocsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeletePluginVersionDocs = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionDocs>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginVersionDocs>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionDocsBody},
        TContext
      > => {
      return useMutation(getDeletePluginVersionDocsMutationOptions(options));
    }

/**
 * List tables for a given plugin version. This only applies to source plugins.
 */
export const getListPluginVersionTablesUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables?${stringifiedParams}` : `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`
}

export const listPluginVersionTables = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams, options?: RequestInit) => {

  return customFetch<ListPluginVersionTables200>(getListPluginVersionTablesUrl(teamName,pluginKind,pluginName,versionName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPluginVersionTablesQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPluginVersionTablesQueryOptions = <TData = Awaited<ReturnType<typeof listPluginVersionTables>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionTables>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginVersionTablesQueryKey(teamName,pluginKind,pluginName,versionName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginVersionTables>>> = ({ signal }) => listPluginVersionTables(teamName,pluginKind,pluginName,versionName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionTables>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginVersionTablesQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginVersionTables>>>
export type ListPluginVersionTablesQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListPluginVersionTables<TData = Awaited<ReturnType<typeof listPluginVersionTables>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    params?: ListPluginVersionTablesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginVersionTables>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginVersionTablesQueryOptions(teamName,pluginKind,pluginName,versionName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create or update one or more plugin version tables. This only applies to source plugins, and can only be done if the plugin version is in draft.
 */
export const getCreatePluginVersionTablesUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`
}

export const createPluginVersionTables = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    createPluginVersionTablesBody: CreatePluginVersionTablesBody, options?: RequestInit) => {

  return customFetch<CreatePluginVersionTables201>(getCreatePluginVersionTablesUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createPluginVersionTablesBody,)
  }
);}




export const getCreatePluginVersionTablesMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody}, TContext> => {

const mutationKey = ['createPluginVersionTables'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPluginVersionTables>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  createPluginVersionTables(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePluginVersionTablesMutationResult = NonNullable<Awaited<ReturnType<typeof createPluginVersionTables>>>
    export type CreatePluginVersionTablesMutationBody = CreatePluginVersionTablesBody
    export type CreatePluginVersionTablesMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreatePluginVersionTables = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPluginVersionTables>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: CreatePluginVersionTablesBody},
        TContext
      > => {
      return useMutation(getCreatePluginVersionTablesMutationOptions(options));
    }

/**
 * Delete one or more plugin version tables.
 */
export const getDeletePluginVersionTablesUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables`
}

export const deletePluginVersionTables = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    deletePluginVersionTablesBody: DeletePluginVersionTablesBody, options?: RequestInit) => {

  return customFetch<void>(getDeletePluginVersionTablesUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deletePluginVersionTablesBody,)
  }
);}




export const getDeletePluginVersionTablesMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody}, TContext> => {

const mutationKey = ['deletePluginVersionTables'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginVersionTables>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  deletePluginVersionTables(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginVersionTablesMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginVersionTables>>>
    export type DeletePluginVersionTablesMutationBody = DeletePluginVersionTablesBody
    export type DeletePluginVersionTablesMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeletePluginVersionTables = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginVersionTables>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginVersionTables>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: DeletePluginVersionTablesBody},
        TContext
      > => {
      return useMutation(getDeletePluginVersionTablesMutationOptions(options));
    }

/**
 * Get schema for a given table and plugin version. This only applies to source plugins.
 */
export const getGetPluginVersionTableUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables/${tableName}`
}

export const getPluginVersionTable = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: RequestInit) => {

  return customFetch<PluginTableDetails>(getGetPluginVersionTableUrl(teamName,pluginKind,pluginName,versionName,tableName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPluginVersionTableQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/tables/${tableName}`
    ] as const;
    }


export const getGetPluginVersionTableQueryOptions = <TData = Awaited<ReturnType<typeof getPluginVersionTable>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginVersionTable>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginVersionTableQueryKey(teamName,pluginKind,pluginName,versionName,tableName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPluginVersionTable>>> = ({ signal }) => getPluginVersionTable(teamName,pluginKind,pluginName,versionName,tableName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName && tableName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPluginVersionTable>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPluginVersionTableQueryResult = NonNullable<Awaited<ReturnType<typeof getPluginVersionTable>>>
export type GetPluginVersionTableQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetPluginVersionTable<TData = Awaited<ReturnType<typeof getPluginVersionTable>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    tableName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPluginVersionTable>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPluginVersionTableQueryOptions(teamName,pluginKind,pluginName,versionName,tableName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Download an asset for a given plugin version and target
 */
export const getDownloadPluginAssetUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
}

export const downloadPluginAsset = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: RequestInit) => {

  return customFetch<PluginAsset>(getDownloadPluginAssetUrl(teamName,pluginKind,pluginName,versionName,targetName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPluginAssetQueryKey = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {
    return [
    `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
    ] as const;
    }


export const getDownloadPluginAssetQueryOptions = <TData = Awaited<ReturnType<typeof downloadPluginAsset>>, TError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPluginAssetQueryKey(teamName,pluginKind,pluginName,versionName,targetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPluginAsset>>> = ({ signal }) => downloadPluginAsset(teamName,pluginKind,pluginName,versionName,targetName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginKind && pluginName && versionName && targetName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPluginAssetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPluginAsset>>>
export type DownloadPluginAssetQueryError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDownloadPluginAsset<TData = Awaited<ReturnType<typeof downloadPluginAsset>>, TError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPluginAssetQueryOptions(teamName,pluginKind,pluginName,versionName,targetName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a URL to upload an asset for a given plugin version and target
 */
export const getUploadPluginAssetUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
}

export const uploadPluginAsset = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: RequestInit) => {

  return customFetch<ReleaseURL>(getUploadPluginAssetUrl(teamName,pluginKind,pluginName,versionName,targetName),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUploadPluginAssetMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext> => {

const mutationKey = ['uploadPluginAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadPluginAsset>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,targetName} = props ?? {};

          return  uploadPluginAsset(teamName,pluginKind,pluginName,versionName,targetName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadPluginAssetMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPluginAsset>>>

    export type UploadPluginAssetMutationError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useUploadPluginAsset = <TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPluginAsset>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadPluginAsset>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;targetName: string},
        TContext
      > => {
      return useMutation(getUploadPluginAssetMutationOptions(options));
    }

/**
 * Get URLs to upload UI assets for a given plugin version
 */
export const getUploadPluginUIAssetsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`
}

export const uploadPluginUIAssets = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    uploadPluginUIAssetsBody: UploadPluginUIAssetsBody, options?: RequestInit) => {

  return customFetch<UploadPluginUIAssets201>(getUploadPluginUIAssetsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      uploadPluginUIAssetsBody,)
  }
);}




export const getUploadPluginUIAssetsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody}, TContext> => {

const mutationKey = ['uploadPluginUIAssets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadPluginUIAssets>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  uploadPluginUIAssets(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadPluginUIAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadPluginUIAssets>>>
    export type UploadPluginUIAssetsMutationBody = UploadPluginUIAssetsBody
    export type UploadPluginUIAssetsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useUploadPluginUIAssets = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadPluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadPluginUIAssets>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: UploadPluginUIAssetsBody},
        TContext
      > => {
      return useMutation(getUploadPluginUIAssetsMutationOptions(options));
    }

/**
 * Finalize UI asset upload
 */
export const getFinalizePluginUIAssetUploadUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`
}

export const finalizePluginUIAssetUpload = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    finalizePluginUIAssetUploadBody: FinalizePluginUIAssetUploadBody, options?: RequestInit) => {

  return customFetch<void>(getFinalizePluginUIAssetUploadUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      finalizePluginUIAssetUploadBody,)
  }
);}




export const getFinalizePluginUIAssetUploadMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody}, TContext> => {

const mutationKey = ['finalizePluginUIAssetUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName,data} = props ?? {};

          return  finalizePluginUIAssetUpload(teamName,pluginKind,pluginName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FinalizePluginUIAssetUploadMutationResult = NonNullable<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>>
    export type FinalizePluginUIAssetUploadMutationBody = FinalizePluginUIAssetUploadBody
    export type FinalizePluginUIAssetUploadMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useFinalizePluginUIAssetUpload = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof finalizePluginUIAssetUpload>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string;data: FinalizePluginUIAssetUploadBody},
        TContext
      > => {
      return useMutation(getFinalizePluginUIAssetUploadMutationOptions(options));
    }

/**
 * Remove UI assets for a given plugin version
 */
export const getRemovePluginUIAssetsUrl = (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,) => {




  return `/plugins/${teamName}/${pluginKind}/${pluginName}/versions/${versionName}/uiassets`
}

export const removePluginUIAssets = async (teamName: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string, options?: RequestInit) => {

  return customFetch<void>(getRemovePluginUIAssetsUrl(teamName,pluginKind,pluginName,versionName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemovePluginUIAssetsMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext> => {

const mutationKey = ['removePluginUIAssets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removePluginUIAssets>>, {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}> = (props) => {
          const {teamName,pluginKind,pluginName,versionName} = props ?? {};

          return  removePluginUIAssets(teamName,pluginKind,pluginName,versionName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemovePluginUIAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof removePluginUIAssets>>>

    export type RemovePluginUIAssetsMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useRemovePluginUIAssets = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePluginUIAssets>>, TError,{teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removePluginUIAssets>>,
        TError,
        {teamName: string;pluginKind: 'source' | 'destination' | 'transformer';pluginName: string;versionName: string},
        TContext
      > => {
      return useMutation(getRemovePluginUIAssetsMutationOptions(options));
    }

/**
 * List all addons
 */
export const getListAddonsUrl = (params?: ListAddonsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/addons?${stringifiedParams}` : `/addons`
}

export const listAddons = async (params?: ListAddonsParams, options?: RequestInit) => {

  return customFetch<ListAddons200>(getListAddonsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAddonsQueryKey = (params?: ListAddonsParams,) => {
    return [
    `/addons`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAddonsQueryOptions = <TData = Awaited<ReturnType<typeof listAddons>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(params?: ListAddonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddons>>> = ({ signal }) => listAddons(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAddonsQueryResult = NonNullable<Awaited<ReturnType<typeof listAddons>>>
export type ListAddonsQueryError = RequiresAuthenticationResponse | InternalErrorResponse



export function useListAddons<TData = Awaited<ReturnType<typeof listAddons>>, TError = RequiresAuthenticationResponse | InternalErrorResponse>(
 params?: ListAddonsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddons>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAddonsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create an addon owned by the specified team. User must be part of that team.
 */
export const getCreateAddonUrl = () => {




  return `/addons`
}

export const createAddon = async (addonCreate: AddonCreate, options?: RequestInit) => {

  return customFetch<Addon>(getCreateAddonUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addonCreate,)
  }
);}




export const getCreateAddonMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddon>>, TError,{data: AddonCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAddon>>, TError,{data: AddonCreate}, TContext> => {

const mutationKey = ['createAddon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAddon>>, {data: AddonCreate}> = (props) => {
          const {data} = props ?? {};

          return  createAddon(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAddonMutationResult = NonNullable<Awaited<ReturnType<typeof createAddon>>>
    export type CreateAddonMutationBody = AddonCreate
    export type CreateAddonMutationError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateAddon = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddon>>, TError,{data: AddonCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAddon>>,
        TError,
        {data: AddonCreate},
        TContext
      > => {
      return useMutation(getCreateAddonMutationOptions(options));
    }

/**
 * Get details about a given addon.
 */
export const getGetAddonUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,) => {




  return `/addons/${teamName}/${addonType}/${addonName}`
}

export const getAddon = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string, options?: RequestInit) => {

  return customFetch<ListAddon>(getGetAddonUrl(teamName,addonType,addonName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAddonQueryKey = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,) => {
    return [
    `/addons/${teamName}/${addonType}/${addonName}`
    ] as const;
    }


export const getGetAddonQueryOptions = <TData = Awaited<ReturnType<typeof getAddon>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddon>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddonQueryKey(teamName,addonType,addonName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddon>>> = ({ signal }) => getAddon(teamName,addonType,addonName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && addonType && addonName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddon>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddonQueryResult = NonNullable<Awaited<ReturnType<typeof getAddon>>>
export type GetAddonQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetAddon<TData = Awaited<ReturnType<typeof getAddon>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddon>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAddonQueryOptions(teamName,addonType,addonName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update an Addon
 */
export const getUpdateAddonUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,) => {




  return `/addons/${teamName}/${addonType}/${addonName}`
}

export const updateAddon = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    addonUpdate: AddonUpdate, options?: RequestInit) => {

  return customFetch<Addon>(getUpdateAddonUrl(teamName,addonType,addonName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addonUpdate,)
  }
);}




export const getUpdateAddonMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAddon>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAddon>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate}, TContext> => {

const mutationKey = ['updateAddon'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAddon>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate}> = (props) => {
          const {teamName,addonType,addonName,data} = props ?? {};

          return  updateAddon(teamName,addonType,addonName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAddonMutationResult = NonNullable<Awaited<ReturnType<typeof updateAddon>>>
    export type UpdateAddonMutationBody = AddonUpdate
    export type UpdateAddonMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateAddon = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAddon>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAddon>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;data: AddonUpdate},
        TContext
      > => {
      return useMutation(getUpdateAddonMutationOptions(options));
    }

/**
 * Delete addon by team and addon name
 */
export const getDeleteAddonByTeamAndNameUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,) => {




  return `/addons/${teamName}/${addonType}/${addonName}`
}

export const deleteAddonByTeamAndName = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string, options?: RequestInit) => {

  return customFetch<void>(getDeleteAddonByTeamAndNameUrl(teamName,addonType,addonName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAddonByTeamAndNameMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string}, TContext> => {

const mutationKey = ['deleteAddonByTeamAndName'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string}> = (props) => {
          const {teamName,addonType,addonName} = props ?? {};

          return  deleteAddonByTeamAndName(teamName,addonType,addonName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddonByTeamAndNameMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>>

    export type DeleteAddonByTeamAndNameMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteAddonByTeamAndName = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddonByTeamAndName>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAddonByTeamAndName>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string},
        TContext
      > => {
      return useMutation(getDeleteAddonByTeamAndNameMutationOptions(options));
    }

/**
 * List all versions for a given addon
 */
export const getListAddonVersionsUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/addons/${teamName}/${addonType}/${addonName}/versions?${stringifiedParams}` : `/addons/${teamName}/${addonType}/${addonName}/versions`
}

export const listAddonVersions = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams, options?: RequestInit) => {

  return customFetch<ListAddonVersions200>(getListAddonVersionsUrl(teamName,addonType,addonName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAddonVersionsQueryKey = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams,) => {
    return [
    `/addons/${teamName}/${addonType}/${addonName}/versions`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAddonVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listAddonVersions>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonVersionsQueryKey(teamName,addonType,addonName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddonVersions>>> = ({ signal }) => listAddonVersions(teamName,addonType,addonName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && addonType && addonName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddonVersions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAddonVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAddonVersions>>>
export type ListAddonVersionsQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListAddonVersions<TData = Awaited<ReturnType<typeof listAddonVersions>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    params?: ListAddonVersionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonVersions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAddonVersionsQueryOptions(teamName,addonType,addonName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get details about a given addon version.
 */
export const getGetAddonVersionUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {




  return `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}`
}

export const getAddonVersion = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: RequestInit) => {

  return customFetch<AddonVersion>(getGetAddonVersionUrl(teamName,addonType,addonName,versionName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAddonVersionQueryKey = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {
    return [
    `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}`
    ] as const;
    }


export const getGetAddonVersionQueryOptions = <TData = Awaited<ReturnType<typeof getAddonVersion>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddonVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddonVersionQueryKey(teamName,addonType,addonName,versionName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddonVersion>>> = ({ signal }) => getAddonVersion(teamName,addonType,addonName,versionName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && addonType && addonName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddonVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddonVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getAddonVersion>>>
export type GetAddonVersionQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetAddonVersion<TData = Awaited<ReturnType<typeof getAddonVersion>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddonVersion>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAddonVersionQueryOptions(teamName,addonType,addonName,versionName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a new addon version, or update a draft version
 */
export const getCreateAddonVersionUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {




  return `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}`
}

export const createAddonVersion = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,
    createAddonVersionBody: CreateAddonVersionBody, options?: RequestInit) => {

  return customFetch<AddonVersion>(getCreateAddonVersionUrl(teamName,addonType,addonName,versionName),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAddonVersionBody,)
  }
);}




export const getCreateAddonVersionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody}, TContext> => {

const mutationKey = ['createAddonVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAddonVersion>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody}> = (props) => {
          const {teamName,addonType,addonName,versionName,data} = props ?? {};

          return  createAddonVersion(teamName,addonType,addonName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAddonVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createAddonVersion>>>
    export type CreateAddonVersionMutationBody = CreateAddonVersionBody
    export type CreateAddonVersionMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useCreateAddonVersion = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAddonVersion>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: CreateAddonVersionBody},
        TContext
      > => {
      return useMutation(getCreateAddonVersionMutationOptions(options));
    }

/**
 * Update a given addon version
 */
export const getUpdateAddonVersionUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {




  return `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}`
}

export const updateAddonVersion = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,
    addonVersionUpdate: AddonVersionUpdate, options?: RequestInit) => {

  return customFetch<AddonVersion>(getUpdateAddonVersionUrl(teamName,addonType,addonName,versionName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addonVersionUpdate,)
  }
);}




export const getUpdateAddonVersionMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate}, TContext> => {

const mutationKey = ['updateAddonVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAddonVersion>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate}> = (props) => {
          const {teamName,addonType,addonName,versionName,data} = props ?? {};

          return  updateAddonVersion(teamName,addonType,addonName,versionName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAddonVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updateAddonVersion>>>
    export type UpdateAddonVersionMutationBody = AddonVersionUpdate
    export type UpdateAddonVersionMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdateAddonVersion = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAddonVersion>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAddonVersion>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string;data: AddonVersionUpdate},
        TContext
      > => {
      return useMutation(getUpdateAddonVersionMutationOptions(options));
    }

/**
 * Download an asset for a given version
 */
export const getDownloadAddonAssetUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {




  return `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}/assets`
}

export const downloadAddonAsset = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: RequestInit) => {

  return customFetch<AddonAsset>(getDownloadAddonAssetUrl(teamName,addonType,addonName,versionName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadAddonAssetQueryKey = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {
    return [
    `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}/assets`
    ] as const;
    }


export const getDownloadAddonAssetQueryOptions = <TData = Awaited<ReturnType<typeof downloadAddonAsset>>, TError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadAddonAssetQueryKey(teamName,addonType,addonName,versionName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAddonAsset>>> = ({ signal }) => downloadAddonAsset(teamName,addonType,addonName,versionName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && addonType && addonName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAsset>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadAddonAssetQueryResult = NonNullable<Awaited<ReturnType<typeof downloadAddonAsset>>>
export type DownloadAddonAssetQueryError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDownloadAddonAsset<TData = Awaited<ReturnType<typeof downloadAddonAsset>>, TError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAsset>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadAddonAssetQueryOptions(teamName,addonType,addonName,versionName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a URL to upload an asset for a given addon version
 */
export const getUploadAddonAssetUrl = (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {




  return `/addons/${teamName}/${addonType}/${addonName}/versions/${versionName}/assets`
}

export const uploadAddonAsset = async (teamName: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: RequestInit) => {

  return customFetch<ReleaseURL>(getUploadAddonAssetUrl(teamName,addonType,addonName,versionName),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUploadAddonAssetMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAddonAsset>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadAddonAsset>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string}, TContext> => {

const mutationKey = ['uploadAddonAsset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadAddonAsset>>, {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string}> = (props) => {
          const {teamName,addonType,addonName,versionName} = props ?? {};

          return  uploadAddonAsset(teamName,addonType,addonName,versionName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadAddonAssetMutationResult = NonNullable<Awaited<ReturnType<typeof uploadAddonAsset>>>

    export type UploadAddonAssetMutationError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse

    export const useUploadAddonAsset = <TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadAddonAsset>>, TError,{teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof uploadAddonAsset>>,
        TError,
        {teamName: string;addonType: 'transformation' | 'visualization';addonName: string;versionName: string},
        TContext
      > => {
      return useMutation(getUploadAddonAssetMutationOptions(options));
    }

/**
 * List all teams
 */
export const getListTeamsUrl = (params?: ListTeamsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams?${stringifiedParams}` : `/teams`
}

export const listTeams = async (params?: ListTeamsParams, options?: RequestInit) => {

  return customFetch<ListTeams200>(getListTeamsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamsQueryKey = (params?: ListTeamsParams,) => {
    return [
    `/teams`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTeamsQueryOptions = <TData = Awaited<ReturnType<typeof listTeams>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(params?: ListTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeams>>> = ({ signal }) => listTeams(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeams>>>
export type ListTeamsQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListTeams<TData = Awaited<ReturnType<typeof listTeams>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 params?: ListTeamsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a team owned by the current user.
 */
export const getCreateTeamUrl = () => {




  return `/teams`
}

export const createTeam = async (createTeamBody: CreateTeamBody, options?: RequestInit) => {

  return customFetch<Team>(getCreateTeamUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTeamBody,)
  }
);}




export const getCreateTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: CreateTeamBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: CreateTeamBody}, TContext> => {

const mutationKey = ['createTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeam>>, {data: CreateTeamBody}> = (props) => {
          const {data} = props ?? {};

          return  createTeam(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createTeam>>>
    export type CreateTeamMutationBody = CreateTeamBody
    export type CreateTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeam>>, TError,{data: CreateTeamBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeam>>,
        TError,
        {data: CreateTeamBody},
        TContext
      > => {
      return useMutation(getCreateTeamMutationOptions(options));
    }

/**
 * Get a team by name
 */
export const getGetTeamByNameUrl = (teamName: string,) => {




  return `/teams/${teamName}`
}

export const getTeamByName = async (teamName: string, options?: RequestInit) => {

  return customFetch<Team>(getGetTeamByNameUrl(teamName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamByNameQueryKey = (teamName: string,) => {
    return [
    `/teams/${teamName}`
    ] as const;
    }


export const getGetTeamByNameQueryOptions = <TData = Awaited<ReturnType<typeof getTeamByName>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamByName>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamByNameQueryKey(teamName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamByName>>> = ({ signal }) => getTeamByName(teamName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamByName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamByNameQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamByName>>>
export type GetTeamByNameQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetTeamByName<TData = Awaited<ReturnType<typeof getTeamByName>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamByName>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamByNameQueryOptions(teamName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update team attributes
 */
export const getUpdateTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}`
}

export const updateTeam = async (teamName: string,
    updateTeamBody: UpdateTeamBody, options?: RequestInit) => {

  return customFetch<Team>(getUpdateTeamUrl(teamName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateTeamBody,)
  }
);}




export const getUpdateTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamName: string;data: UpdateTeamBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamName: string;data: UpdateTeamBody}, TContext> => {

const mutationKey = ['updateTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTeam>>, {teamName: string;data: UpdateTeamBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  updateTeam(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTeamMutationResult = NonNullable<Awaited<ReturnType<typeof updateTeam>>>
    export type UpdateTeamMutationBody = UpdateTeamBody
    export type UpdateTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdateTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTeam>>, TError,{teamName: string;data: UpdateTeamBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateTeam>>,
        TError,
        {teamName: string;data: UpdateTeamBody},
        TContext
      > => {
      return useMutation(getUpdateTeamMutationOptions(options));
    }

/**
 * Delete team
 */
export const getDeleteTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}`
}

export const deleteTeam = async (teamName: string, options?: RequestInit) => {

  return customFetch<void>(getDeleteTeamUrl(teamName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['deleteTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  deleteTeam(teamName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeam>>>

    export type DeleteTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {
      return useMutation(getDeleteTeamMutationOptions(options));
    }

/**
 * Get URLs to upload images for a given team
 */
export const getCreateTeamImagesUrl = (teamName: string,) => {




  return `/teams/${teamName}/images`
}

export const createTeamImages = async (teamName: string,
    createTeamImagesBody: CreateTeamImagesBody, options?: RequestInit) => {

  return customFetch<CreateTeamImages201>(getCreateTeamImagesUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTeamImagesBody,)
  }
);}




export const getCreateTeamImagesMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamImages>>, TError,{teamName: string;data: CreateTeamImagesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeamImages>>, TError,{teamName: string;data: CreateTeamImagesBody}, TContext> => {

const mutationKey = ['createTeamImages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeamImages>>, {teamName: string;data: CreateTeamImagesBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createTeamImages(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamImagesMutationResult = NonNullable<Awaited<ReturnType<typeof createTeamImages>>>
    export type CreateTeamImagesMutationBody = CreateTeamImagesBody
    export type CreateTeamImagesMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useCreateTeamImages = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamImages>>, TError,{teamName: string;data: CreateTeamImagesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeamImages>>,
        TError,
        {teamName: string;data: CreateTeamImagesBody},
        TContext
      > => {
      return useMutation(getCreateTeamImagesMutationOptions(options));
    }

/**
 * List all plugins for the team.
 */
export const getListPluginsByTeamUrl = (teamName: string,
    params?: ListPluginsByTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/plugins?${stringifiedParams}` : `/teams/${teamName}/plugins`
}

export const listPluginsByTeam = async (teamName: string,
    params?: ListPluginsByTeamParams, options?: RequestInit) => {

  return customFetch<ListPluginsByTeam200>(getListPluginsByTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPluginsByTeamQueryKey = (teamName: string,
    params?: ListPluginsByTeamParams,) => {
    return [
    `/teams/${teamName}/plugins`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPluginsByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listPluginsByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListPluginsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginsByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginsByTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginsByTeam>>> = ({ signal }) => listPluginsByTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginsByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginsByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginsByTeam>>>
export type ListPluginsByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListPluginsByTeam<TData = Awaited<ReturnType<typeof listPluginsByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListPluginsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginsByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginsByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Delete plugins by team
 */
export const getDeletePluginsByTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}/plugins`
}

export const deletePluginsByTeam = async (teamName: string, options?: RequestInit) => {

  return customFetch<void>(getDeletePluginsByTeamUrl(teamName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeletePluginsByTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginsByTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePluginsByTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['deletePluginsByTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePluginsByTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  deletePluginsByTeam(teamName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePluginsByTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deletePluginsByTeam>>>

    export type DeletePluginsByTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeletePluginsByTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePluginsByTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePluginsByTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {
      return useMutation(getDeletePluginsByTeamMutationOptions(options));
    }

/**
 * List all addons for the team.
 */
export const getListAddonsByTeamUrl = (teamName: string,
    params?: ListAddonsByTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/addons?${stringifiedParams}` : `/teams/${teamName}/addons`
}

export const listAddonsByTeam = async (teamName: string,
    params?: ListAddonsByTeamParams, options?: RequestInit) => {

  return customFetch<ListAddonsByTeam200>(getListAddonsByTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAddonsByTeamQueryKey = (teamName: string,
    params?: ListAddonsByTeamParams,) => {
    return [
    `/teams/${teamName}/addons`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAddonsByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listAddonsByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListAddonsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonsByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonsByTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddonsByTeam>>> = ({ signal }) => listAddonsByTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddonsByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAddonsByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listAddonsByTeam>>>
export type ListAddonsByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListAddonsByTeam<TData = Awaited<ReturnType<typeof listAddonsByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListAddonsByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonsByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAddonsByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Delete addons by team
 */
export const getDeleteAddonsByTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}/addons`
}

export const deleteAddonsByTeam = async (teamName: string, options?: RequestInit) => {

  return customFetch<void>(getDeleteAddonsByTeamUrl(teamName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAddonsByTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddonsByTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAddonsByTeam>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['deleteAddonsByTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAddonsByTeam>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  deleteAddonsByTeam(teamName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddonsByTeamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddonsByTeam>>>

    export type DeleteAddonsByTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteAddonsByTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddonsByTeam>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAddonsByTeam>>,
        TError,
        {teamName: string},
        TContext
      > => {
      return useMutation(getDeleteAddonsByTeamMutationOptions(options));
    }

/**
 * List all addon orders for the team.
 */
export const getListAddonOrdersByTeamUrl = (teamName: string,
    params?: ListAddonOrdersByTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/addon-orders?${stringifiedParams}` : `/teams/${teamName}/addon-orders`
}

export const listAddonOrdersByTeam = async (teamName: string,
    params?: ListAddonOrdersByTeamParams, options?: RequestInit) => {

  return customFetch<ListAddonOrdersByTeam200>(getListAddonOrdersByTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAddonOrdersByTeamQueryKey = (teamName: string,
    params?: ListAddonOrdersByTeamParams,) => {
    return [
    `/teams/${teamName}/addon-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAddonOrdersByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListAddonOrdersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAddonOrdersByTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAddonOrdersByTeam>>> = ({ signal }) => listAddonOrdersByTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAddonOrdersByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listAddonOrdersByTeam>>>
export type ListAddonOrdersByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListAddonOrdersByTeam<TData = Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListAddonOrdersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAddonOrdersByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAddonOrdersByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Start the checkout process for an addon order.
 */
export const getCreateAddonOrderForTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}/addon-orders`
}

export const createAddonOrderForTeam = async (teamName: string,
    addonOrderCreate: AddonOrderCreate, options?: RequestInit) => {

  return customFetch<AddonOrder>(getCreateAddonOrderForTeamUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addonOrderCreate,)
  }
);}




export const getCreateAddonOrderForTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddonOrderForTeam>>, TError,{teamName: string;data: AddonOrderCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAddonOrderForTeam>>, TError,{teamName: string;data: AddonOrderCreate}, TContext> => {

const mutationKey = ['createAddonOrderForTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAddonOrderForTeam>>, {teamName: string;data: AddonOrderCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createAddonOrderForTeam(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAddonOrderForTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createAddonOrderForTeam>>>
    export type CreateAddonOrderForTeamMutationBody = AddonOrderCreate
    export type CreateAddonOrderForTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useCreateAddonOrderForTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAddonOrderForTeam>>, TError,{teamName: string;data: AddonOrderCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAddonOrderForTeam>>,
        TError,
        {teamName: string;data: AddonOrderCreate},
        TContext
      > => {
      return useMutation(getCreateAddonOrderForTeamMutationOptions(options));
    }

/**
 * Get an addon order for the team.
 */
export const getGetAddonOrderByTeamUrl = (teamName: string,
    addonOrderId: string,) => {




  return `/teams/${teamName}/addon-orders/${addonOrderId}`
}

export const getAddonOrderByTeam = async (teamName: string,
    addonOrderId: string, options?: RequestInit) => {

  return customFetch<AddonOrder>(getGetAddonOrderByTeamUrl(teamName,addonOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAddonOrderByTeamQueryKey = (teamName: string,
    addonOrderId: string,) => {
    return [
    `/teams/${teamName}/addon-orders/${addonOrderId}`
    ] as const;
    }


export const getGetAddonOrderByTeamQueryOptions = <TData = Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    addonOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddonOrderByTeamQueryKey(teamName,addonOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddonOrderByTeam>>> = ({ signal }) => getAddonOrderByTeam(teamName,addonOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && addonOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAddonOrderByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getAddonOrderByTeam>>>
export type GetAddonOrderByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetAddonOrderByTeam<TData = Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    addonOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAddonOrderByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAddonOrderByTeamQueryOptions(teamName,addonOrderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get memberships to the team.
 */
export const getGetTeamMembershipsUrl = (teamName: string,
    params?: GetTeamMembershipsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/memberships?${stringifiedParams}` : `/teams/${teamName}/memberships`
}

export const getTeamMemberships = async (teamName: string,
    params?: GetTeamMembershipsParams, options?: RequestInit) => {

  return customFetch<GetTeamMemberships200>(getGetTeamMembershipsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamMembershipsQueryKey = (teamName: string,
    params?: GetTeamMembershipsParams,) => {
    return [
    `/teams/${teamName}/memberships`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getTeamMemberships>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: GetTeamMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberships>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamMembershipsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamMemberships>>> = ({ signal }) => getTeamMemberships(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamMemberships>>>
export type GetTeamMembershipsQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetTeamMemberships<TData = Awaited<ReturnType<typeof getTeamMemberships>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: GetTeamMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamMemberships>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamMembershipsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Remove a user from the team
 */
export const getRemoveTeamMembershipUrl = (teamName: string,) => {




  return `/teams/${teamName}/memberships`
}

export const removeTeamMembership = async (teamName: string,
    removeTeamMembershipBody: RemoveTeamMembershipBody, options?: RequestInit) => {

  return customFetch<void>(getRemoveTeamMembershipUrl(teamName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      removeTeamMembershipBody,)
  }
);}




export const getRemoveTeamMembershipMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTeamMembership>>, TError,{teamName: string;data: RemoveTeamMembershipBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeTeamMembership>>, TError,{teamName: string;data: RemoveTeamMembershipBody}, TContext> => {

const mutationKey = ['removeTeamMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTeamMembership>>, {teamName: string;data: RemoveTeamMembershipBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  removeTeamMembership(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveTeamMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof removeTeamMembership>>>
    export type RemoveTeamMembershipMutationBody = RemoveTeamMembershipBody
    export type RemoveTeamMembershipMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useRemoveTeamMembership = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTeamMembership>>, TError,{teamName: string;data: RemoveTeamMembershipBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removeTeamMembership>>,
        TError,
        {teamName: string;data: RemoveTeamMembershipBody},
        TContext
      > => {
      return useMutation(getRemoveTeamMembershipMutationOptions(options));
    }

/**
 * Remove a user from the team
 * @deprecated
 */
export const getDeleteTeamMembershipUrl = (teamName: string,
    email: string,) => {




  return `/teams/${teamName}/memberships/${email}`
}

export const deleteTeamMembership = async (teamName: string,
    email: string, options?: RequestInit) => {

  return customFetch<void>(getDeleteTeamMembershipUrl(teamName,email),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTeamMembershipMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamMembership>>, TError,{teamName: string;email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamMembership>>, TError,{teamName: string;email: string}, TContext> => {

const mutationKey = ['deleteTeamMembership'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamMembership>>, {teamName: string;email: string}> = (props) => {
          const {teamName,email} = props ?? {};

          return  deleteTeamMembership(teamName,email,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamMembership>>>

    export type DeleteTeamMembershipMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    /**
 * @deprecated
 */
export const useDeleteTeamMembership = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamMembership>>, TError,{teamName: string;email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamMembership>>,
        TError,
        {teamName: string;email: string},
        TContext
      > => {
      return useMutation(getDeleteTeamMembershipMutationOptions(options));
    }

/**
 * List all past invoices for the team.
 */
export const getListInvoicesByTeamUrl = (teamName: string,
    params?: ListInvoicesByTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/invoices?${stringifiedParams}` : `/teams/${teamName}/invoices`
}

export const listInvoicesByTeam = async (teamName: string,
    params?: ListInvoicesByTeamParams, options?: RequestInit) => {

  return customFetch<ListInvoicesByTeam200>(getListInvoicesByTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvoicesByTeamQueryKey = (teamName: string,
    params?: ListInvoicesByTeamParams,) => {
    return [
    `/teams/${teamName}/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInvoicesByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listInvoicesByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListInvoicesByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoicesByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoicesByTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoicesByTeam>>> = ({ signal }) => listInvoicesByTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoicesByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvoicesByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoicesByTeam>>>
export type ListInvoicesByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListInvoicesByTeam<TData = Awaited<ReturnType<typeof listInvoicesByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListInvoicesByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoicesByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvoicesByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List plugin usage for the current calendar month.
 */
export const getListTeamPluginUsageUrl = (teamName: string,
    params?: ListTeamPluginUsageParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/usage?${stringifiedParams}` : `/teams/${teamName}/usage`
}

export const listTeamPluginUsage = async (teamName: string,
    params?: ListTeamPluginUsageParams, options?: RequestInit) => {

  return customFetch<ListTeamPluginUsage200>(getListTeamPluginUsageUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamPluginUsageQueryKey = (teamName: string,
    params?: ListTeamPluginUsageParams,) => {
    return [
    `/teams/${teamName}/usage`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTeamPluginUsageQueryOptions = <TData = Awaited<ReturnType<typeof listTeamPluginUsage>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListTeamPluginUsageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamPluginUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamPluginUsageQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamPluginUsage>>> = ({ signal }) => listTeamPluginUsage(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamPluginUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamPluginUsageQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamPluginUsage>>>
export type ListTeamPluginUsageQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListTeamPluginUsage<TData = Awaited<ReturnType<typeof listTeamPluginUsage>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListTeamPluginUsageParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamPluginUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamPluginUsageQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Increase the usage of a plugin. This can incur billing costs and should be used only by plugin SDKs.
 */
export const getIncreaseTeamPluginUsageUrl = (teamName: string,) => {




  return `/teams/${teamName}/usage`
}

export const increaseTeamPluginUsage = async (teamName: string,
    usageIncrease: UsageIncrease, options?: RequestInit) => {

  return customFetch<void>(getIncreaseTeamPluginUsageUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      usageIncrease,)
  }
);}




export const getIncreaseTeamPluginUsageMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof increaseTeamPluginUsage>>, TError,{teamName: string;data: UsageIncrease}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof increaseTeamPluginUsage>>, TError,{teamName: string;data: UsageIncrease}, TContext> => {

const mutationKey = ['increaseTeamPluginUsage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof increaseTeamPluginUsage>>, {teamName: string;data: UsageIncrease}> = (props) => {
          const {teamName,data} = props ?? {};

          return  increaseTeamPluginUsage(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type IncreaseTeamPluginUsageMutationResult = NonNullable<Awaited<ReturnType<typeof increaseTeamPluginUsage>>>
    export type IncreaseTeamPluginUsageMutationBody = UsageIncrease
    export type IncreaseTeamPluginUsageMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse | ServiceUnavailableResponse

    export const useIncreaseTeamPluginUsage = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse | ServiceUnavailableResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof increaseTeamPluginUsage>>, TError,{teamName: string;data: UsageIncrease}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof increaseTeamPluginUsage>>,
        TError,
        {teamName: string;data: UsageIncrease},
        TContext
      > => {
      return useMutation(getIncreaseTeamPluginUsageMutationOptions(options));
    }

/**
 * Get plugin usage for the current calendar month.
 */
export const getGetTeamPluginUsageUrl = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {




  return `/teams/${teamName}/usage/${pluginTeam}/${pluginKind}/${pluginName}`
}

export const getTeamPluginUsage = async (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: RequestInit) => {

  return customFetch<UsageCurrent>(getGetTeamPluginUsageUrl(teamName,pluginTeam,pluginKind,pluginName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamPluginUsageQueryKey = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,) => {
    return [
    `/teams/${teamName}/usage/${pluginTeam}/${pluginKind}/${pluginName}`
    ] as const;
    }


export const getGetTeamPluginUsageQueryOptions = <TData = Awaited<ReturnType<typeof getTeamPluginUsage>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamPluginUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamPluginUsageQueryKey(teamName,pluginTeam,pluginKind,pluginName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamPluginUsage>>> = ({ signal }) => getTeamPluginUsage(teamName,pluginTeam,pluginKind,pluginName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginTeam && pluginKind && pluginName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamPluginUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamPluginUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamPluginUsage>>>
export type GetTeamPluginUsageQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetTeamPluginUsage<TData = Awaited<ReturnType<typeof getTeamPluginUsage>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamPluginUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamPluginUsageQueryOptions(teamName,pluginTeam,pluginKind,pluginName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a summary of usage for the specified time range.
 */
export const getGetTeamUsageSummaryUrl = (teamName: string,
    params?: GetTeamUsageSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/usage-summary?${stringifiedParams}` : `/teams/${teamName}/usage-summary`
}

export const getTeamUsageSummary = async (teamName: string,
    params?: GetTeamUsageSummaryParams, options?: RequestInit) => {

  return customFetch<UsageSummary>(getGetTeamUsageSummaryUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamUsageSummaryQueryKey = (teamName: string,
    params?: GetTeamUsageSummaryParams,) => {
    return [
    `/teams/${teamName}/usage-summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTeamUsageSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getTeamUsageSummary>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    params?: GetTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamUsageSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamUsageSummaryQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamUsageSummary>>> = ({ signal }) => getTeamUsageSummary(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamUsageSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTeamUsageSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamUsageSummary>>>
export type GetTeamUsageSummaryQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetTeamUsageSummary<TData = Awaited<ReturnType<typeof getTeamUsageSummary>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    params?: GetTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTeamUsageSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetTeamUsageSummaryQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a grouped summary of usage for the specified time range.
 */
export const getGetGroupedTeamUsageSummaryUrl = (teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/usage-summary/${groupBy}?${stringifiedParams}` : `/teams/${teamName}/usage-summary/${groupBy}`
}

export const getGroupedTeamUsageSummary = async (teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams, options?: RequestInit) => {

  return customFetch<UsageSummary>(getGetGroupedTeamUsageSummaryUrl(teamName,groupBy,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGroupedTeamUsageSummaryQueryKey = (teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams,) => {
    return [
    `/teams/${teamName}/usage-summary/${groupBy}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupedTeamUsageSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupedTeamUsageSummaryQueryKey(teamName,groupBy,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>> = ({ signal }) => getGroupedTeamUsageSummary(teamName,groupBy,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && groupBy), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGroupedTeamUsageSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>>
export type GetGroupedTeamUsageSummaryQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetGroupedTeamUsageSummary<TData = Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string,
    groupBy: 'price_category' | 'plugin' | 'sync_id',
    params?: GetGroupedTeamUsageSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGroupedTeamUsageSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGroupedTeamUsageSummaryQueryOptions(teamName,groupBy,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Download an asset for a given plugin version as the current team.
 */
export const getDownloadPluginAssetByTeamUrl = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {




  return `/teams/${teamName}/plugins/${pluginTeam}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
}

export const downloadPluginAssetByTeam = async (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: RequestInit) => {

  return customFetch<PluginAsset>(getDownloadPluginAssetByTeamUrl(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadPluginAssetByTeamQueryKey = (teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string,) => {
    return [
    `/teams/${teamName}/plugins/${pluginTeam}/${pluginKind}/${pluginName}/versions/${versionName}/assets/${targetName}`
    ] as const;
    }


export const getDownloadPluginAssetByTeamQueryOptions = <TData = Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadPluginAssetByTeamQueryKey(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>> = ({ signal }) => downloadPluginAssetByTeam(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && pluginTeam && pluginKind && pluginName && versionName && targetName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadPluginAssetByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>>
export type DownloadPluginAssetByTeamQueryError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDownloadPluginAssetByTeam<TData = Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError = void | RequiresAuthenticationResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 teamName: string,
    pluginTeam: string,
    pluginKind: 'source' | 'destination' | 'transformer',
    pluginName: string,
    versionName: string,
    targetName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadPluginAssetByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadPluginAssetByTeamQueryOptions(teamName,pluginTeam,pluginKind,pluginName,versionName,targetName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Download an asset for a given addon version as the current team.
 */
export const getDownloadAddonAssetByTeamUrl = (teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {




  return `/teams/${teamName}/addons/${addonTeam}/${addonType}/${addonName}/versions/${versionName}/assets`
}

export const downloadAddonAssetByTeam = async (teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: RequestInit) => {

  return customFetch<AddonAsset>(getDownloadAddonAssetByTeamUrl(teamName,addonTeam,addonType,addonName,versionName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDownloadAddonAssetByTeamQueryKey = (teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string,) => {
    return [
    `/teams/${teamName}/addons/${addonTeam}/${addonType}/${addonName}/versions/${versionName}/assets`
    ] as const;
    }


export const getDownloadAddonAssetByTeamQueryOptions = <TData = Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDownloadAddonAssetByTeamQueryKey(teamName,addonTeam,addonType,addonName,versionName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>> = ({ signal }) => downloadAddonAssetByTeam(teamName,addonTeam,addonType,addonName,versionName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && addonTeam && addonType && addonName && versionName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type DownloadAddonAssetByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>>
export type DownloadAddonAssetByTeamQueryError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDownloadAddonAssetByTeam<TData = Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError = void | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 teamName: string,
    addonTeam: string,
    addonType: 'transformation' | 'visualization',
    addonName: string,
    versionName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof downloadAddonAssetByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDownloadAddonAssetByTeamQueryOptions(teamName,addonTeam,addonType,addonName,versionName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List of open invitations to the team
 */
export const getListTeamInvitationsUrl = (teamName: string,
    params?: ListTeamInvitationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/invitations?${stringifiedParams}` : `/teams/${teamName}/invitations`
}

export const listTeamInvitations = async (teamName: string,
    params?: ListTeamInvitationsParams, options?: RequestInit) => {

  return customFetch<ListTeamInvitations200>(getListTeamInvitationsUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamInvitationsQueryKey = (teamName: string,
    params?: ListTeamInvitationsParams,) => {
    return [
    `/teams/${teamName}/invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTeamInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listTeamInvitations>>, TError = ForbiddenResponse | InternalErrorResponse>(teamName: string,
    params?: ListTeamInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamInvitationsQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamInvitations>>> = ({ signal }) => listTeamInvitations(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamInvitations>>>
export type ListTeamInvitationsQueryError = ForbiddenResponse | InternalErrorResponse



export function useListTeamInvitations<TData = Awaited<ReturnType<typeof listTeamInvitations>>, TError = ForbiddenResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListTeamInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamInvitationsQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Invite a user to join a team with their email address
 */
export const getEmailTeamInvitationUrl = (teamName: string,) => {




  return `/teams/${teamName}/invitations`
}

export const emailTeamInvitation = async (teamName: string,
    emailTeamInvitationBody: EmailTeamInvitationBody, options?: RequestInit) => {

  return customFetch<Invitation>(getEmailTeamInvitationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      emailTeamInvitationBody,)
  }
);}




export const getEmailTeamInvitationMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailTeamInvitation>>, TError,{teamName: string;data: EmailTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof emailTeamInvitation>>, TError,{teamName: string;data: EmailTeamInvitationBody}, TContext> => {

const mutationKey = ['emailTeamInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailTeamInvitation>>, {teamName: string;data: EmailTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  emailTeamInvitation(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EmailTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof emailTeamInvitation>>>
    export type EmailTeamInvitationMutationBody = EmailTeamInvitationBody
    export type EmailTeamInvitationMutationError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useEmailTeamInvitation = <TError = BadRequestResponse | ForbiddenResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailTeamInvitation>>, TError,{teamName: string;data: EmailTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof emailTeamInvitation>>,
        TError,
        {teamName: string;data: EmailTeamInvitationBody},
        TContext
      > => {
      return useMutation(getEmailTeamInvitationMutationOptions(options));
    }

/**
 * Delete an invitation to the team, preventing the user becoming a team member
 */
export const getDeleteTeamInvitationUrl = (teamName: string,) => {




  return `/teams/${teamName}/invitations`
}

export const deleteTeamInvitation = async (teamName: string,
    deleteTeamInvitationBody: DeleteTeamInvitationBody, options?: RequestInit) => {

  return customFetch<void>(getDeleteTeamInvitationUrl(teamName),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deleteTeamInvitationBody,)
  }
);}




export const getDeleteTeamInvitationMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamInvitation>>, TError,{teamName: string;data: DeleteTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamInvitation>>, TError,{teamName: string;data: DeleteTeamInvitationBody}, TContext> => {

const mutationKey = ['deleteTeamInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamInvitation>>, {teamName: string;data: DeleteTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  deleteTeamInvitation(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamInvitation>>>
    export type DeleteTeamInvitationMutationBody = DeleteTeamInvitationBody
    export type DeleteTeamInvitationMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteTeamInvitation = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamInvitation>>, TError,{teamName: string;data: DeleteTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamInvitation>>,
        TError,
        {teamName: string;data: DeleteTeamInvitationBody},
        TContext
      > => {
      return useMutation(getDeleteTeamInvitationMutationOptions(options));
    }

/**
 * Accept an invitation to the team, creating a user membership
 */
export const getAcceptTeamInvitationUrl = (teamName: string,) => {




  return `/teams/${teamName}/invitations/accept`
}

export const acceptTeamInvitation = async (teamName: string,
    acceptTeamInvitationBody: AcceptTeamInvitationBody, options?: RequestInit) => {

  return customFetch<MembershipWithTeam>(getAcceptTeamInvitationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      acceptTeamInvitationBody,)
  }
);}




export const getAcceptTeamInvitationMutationOptions = <TError = MembershipWithTeam | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTeamInvitation>>, TError,{teamName: string;data: AcceptTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptTeamInvitation>>, TError,{teamName: string;data: AcceptTeamInvitationBody}, TContext> => {

const mutationKey = ['acceptTeamInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTeamInvitation>>, {teamName: string;data: AcceptTeamInvitationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  acceptTeamInvitation(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTeamInvitation>>>
    export type AcceptTeamInvitationMutationBody = AcceptTeamInvitationBody
    export type AcceptTeamInvitationMutationError = MembershipWithTeam | ForbiddenResponse | InternalErrorResponse

    export const useAcceptTeamInvitation = <TError = MembershipWithTeam | ForbiddenResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTeamInvitation>>, TError,{teamName: string;data: AcceptTeamInvitationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptTeamInvitation>>,
        TError,
        {teamName: string;data: AcceptTeamInvitationBody},
        TContext
      > => {
      return useMutation(getAcceptTeamInvitationMutationOptions(options));
    }

/**
 * Cancel an invitation to the team, preventing the user becoming a team member
 * @deprecated
 */
export const getCancelTeamInvitationUrl = (teamName: string,
    email: string,) => {




  return `/teams/${teamName}/invitations/${email}`
}

export const cancelTeamInvitation = async (teamName: string,
    email: string, options?: RequestInit) => {

  return customFetch<void>(getCancelTeamInvitationUrl(teamName,email),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getCancelTeamInvitationMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTeamInvitation>>, TError,{teamName: string;email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelTeamInvitation>>, TError,{teamName: string;email: string}, TContext> => {

const mutationKey = ['cancelTeamInvitation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelTeamInvitation>>, {teamName: string;email: string}> = (props) => {
          const {teamName,email} = props ?? {};

          return  cancelTeamInvitation(teamName,email,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelTeamInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof cancelTeamInvitation>>>

    export type CancelTeamInvitationMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    /**
 * @deprecated
 */
export const useCancelTeamInvitation = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelTeamInvitation>>, TError,{teamName: string;email: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelTeamInvitation>>,
        TError,
        {teamName: string;email: string},
        TContext
      > => {
      return useMutation(getCancelTeamInvitationMutationOptions(options));
    }

/**
 * List all subscription orders for the team.
 */
export const getListSubscriptionOrdersByTeamUrl = (teamName: string,
    params?: ListSubscriptionOrdersByTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/subscription-orders?${stringifiedParams}` : `/teams/${teamName}/subscription-orders`
}

export const listSubscriptionOrdersByTeam = async (teamName: string,
    params?: ListSubscriptionOrdersByTeamParams, options?: RequestInit) => {

  return customFetch<ListSubscriptionOrdersByTeam200>(getListSubscriptionOrdersByTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSubscriptionOrdersByTeamQueryKey = (teamName: string,
    params?: ListSubscriptionOrdersByTeamParams,) => {
    return [
    `/teams/${teamName}/subscription-orders`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSubscriptionOrdersByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListSubscriptionOrdersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSubscriptionOrdersByTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>> = ({ signal }) => listSubscriptionOrdersByTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSubscriptionOrdersByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>>
export type ListSubscriptionOrdersByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListSubscriptionOrdersByTeam<TData = Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListSubscriptionOrdersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSubscriptionOrdersByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSubscriptionOrdersByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Start the checkout process for a subscription order.
 */
export const getCreateSubscriptionOrderForTeamUrl = (teamName: string,) => {




  return `/teams/${teamName}/subscription-orders`
}

export const createSubscriptionOrderForTeam = async (teamName: string,
    teamSubscriptionOrderCreate: TeamSubscriptionOrderCreate, options?: RequestInit) => {

  return customFetch<TeamSubscriptionOrder>(getCreateSubscriptionOrderForTeamUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      teamSubscriptionOrderCreate,)
  }
);}




export const getCreateSubscriptionOrderForTeamMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>, TError,{teamName: string;data: TeamSubscriptionOrderCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>, TError,{teamName: string;data: TeamSubscriptionOrderCreate}, TContext> => {

const mutationKey = ['createSubscriptionOrderForTeam'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>, {teamName: string;data: TeamSubscriptionOrderCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createSubscriptionOrderForTeam(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSubscriptionOrderForTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>>
    export type CreateSubscriptionOrderForTeamMutationBody = TeamSubscriptionOrderCreate
    export type CreateSubscriptionOrderForTeamMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateSubscriptionOrderForTeam = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>, TError,{teamName: string;data: TeamSubscriptionOrderCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createSubscriptionOrderForTeam>>,
        TError,
        {teamName: string;data: TeamSubscriptionOrderCreate},
        TContext
      > => {
      return useMutation(getCreateSubscriptionOrderForTeamMutationOptions(options));
    }

/**
 * Get a subscription order for the team.
 */
export const getGetSubscriptionOrderByTeamUrl = (teamName: string,
    subscriptionOrderId: string,) => {




  return `/teams/${teamName}/subscription-orders/${subscriptionOrderId}`
}

export const getSubscriptionOrderByTeam = async (teamName: string,
    subscriptionOrderId: string, options?: RequestInit) => {

  return customFetch<TeamSubscriptionOrder>(getGetSubscriptionOrderByTeamUrl(teamName,subscriptionOrderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSubscriptionOrderByTeamQueryKey = (teamName: string,
    subscriptionOrderId: string,) => {
    return [
    `/teams/${teamName}/subscription-orders/${subscriptionOrderId}`
    ] as const;
    }


export const getGetSubscriptionOrderByTeamQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    subscriptionOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionOrderByTeamQueryKey(teamName,subscriptionOrderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>> = ({ signal }) => getSubscriptionOrderByTeam(teamName,subscriptionOrderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && subscriptionOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionOrderByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>>
export type GetSubscriptionOrderByTeamQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetSubscriptionOrderByTeam<TData = Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    subscriptionOrderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionOrderByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSubscriptionOrderByTeamQueryOptions(teamName,subscriptionOrderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * List all users in the current team.
 */
export const getListUsersByTeamUrl = (teamName: string,
    params?: ListUsersByTeamParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/users?${stringifiedParams}` : `/teams/${teamName}/users`
}

export const listUsersByTeam = async (teamName: string,
    params?: ListUsersByTeamParams, options?: RequestInit) => {

  return customFetch<ListUsersByTeam200>(getListUsersByTeamUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListUsersByTeamQueryKey = (teamName: string,
    params?: ListUsersByTeamParams,) => {
    return [
    `/teams/${teamName}/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getListUsersByTeamQueryOptions = <TData = Awaited<ReturnType<typeof listUsersByTeam>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListUsersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsersByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUsersByTeamQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsersByTeam>>> = ({ signal }) => listUsersByTeam(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listUsersByTeam>>, TError, TData> & { queryKey: QueryKey }
}

export type ListUsersByTeamQueryResult = NonNullable<Awaited<ReturnType<typeof listUsersByTeam>>>
export type ListUsersByTeamQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useListUsersByTeam<TData = Awaited<ReturnType<typeof listUsersByTeam>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListUsersByTeamParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listUsersByTeam>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListUsersByTeamQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Show current platform settings
 */
export const getGetSettingsUrl = (teamName: string,) => {




  return `/teams/${teamName}/settings`
}

export const getSettings = async (teamName: string, options?: RequestInit) => {

  return customFetch<Settings>(getGetSettingsUrl(teamName),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSettingsQueryKey = (teamName: string,) => {
    return [
    `/teams/${teamName}/settings`
    ] as const;
    }


export const getGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSettings>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsQueryKey(teamName);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings(teamName, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse



export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse>(
 teamName: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSettingsQueryOptions(teamName,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update platform settings
 */
export const getUpdateSettingsUrl = (teamName: string,) => {




  return `/teams/${teamName}/settings`
}

export const updateSettings = async (teamName: string,
    settingsUpdate: SettingsUpdate, options?: RequestInit) => {

  return customFetch<Settings>(getUpdateSettingsUrl(teamName),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      settingsUpdate,)
  }
);}




export const getUpdateSettingsMutationOptions = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{teamName: string;data: SettingsUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{teamName: string;data: SettingsUpdate}, TContext> => {

const mutationKey = ['updateSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSettings>>, {teamName: string;data: SettingsUpdate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  updateSettings(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSettings>>>
    export type UpdateSettingsMutationBody = SettingsUpdate
    export type UpdateSettingsMutationError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUpdateSettings = <TError = RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{teamName: string;data: SettingsUpdate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSettings>>,
        TError,
        {teamName: string;data: SettingsUpdate},
        TContext
      > => {
      return useMutation(getUpdateSettingsMutationOptions(options));
    }

/**
 * Get the current authenticated user from the OAuth token

 */
export const getGetCurrentUserUrl = () => {




  return `/user`
}

export const getCurrentUser = async ( options?: RequestInit) => {

  return customFetch<User>(getGetCurrentUserUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentUserQueryKey = () => {
    return [
    `/user`
    ] as const;
    }


export const getGetCurrentUserQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({ signal }) => getCurrentUser({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUser>>>
export type GetCurrentUserQueryError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse



export function useGetCurrentUser<TData = Awaited<ReturnType<typeof getCurrentUser>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUser>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentUserQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Update attributes for the current authenticated user from the OAuth token
 */
export const getUpdateCurrentUserUrl = () => {




  return `/user`
}

export const updateCurrentUser = async (updateCurrentUserBody: UpdateCurrentUserBody, options?: RequestInit) => {

  return customFetch<User>(getUpdateCurrentUserUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCurrentUserBody,)
  }
);}




export const getUpdateCurrentUserMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext> => {

const mutationKey = ['updateCurrentUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCurrentUser>>, {data: UpdateCurrentUserBody}> = (props) => {
          const {data} = props ?? {};

          return  updateCurrentUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCurrentUserMutationResult = NonNullable<Awaited<ReturnType<typeof updateCurrentUser>>>
    export type UpdateCurrentUserMutationBody = UpdateCurrentUserBody
    export type UpdateCurrentUserMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useUpdateCurrentUser = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCurrentUser>>, TError,{data: UpdateCurrentUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCurrentUser>>,
        TError,
        {data: UpdateCurrentUserBody},
        TContext
      > => {
      return useMutation(getUpdateCurrentUserMutationOptions(options));
    }

/**
 * Check if the current user is authenticated
 */
export const getCheckUserAuthStatusUrl = () => {




  return `/user/authenticated-status`
}

export const checkUserAuthStatus = async ( options?: RequestInit) => {

  return customFetch<CheckUserAuthStatus200>(getCheckUserAuthStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCheckUserAuthStatusQueryKey = () => {
    return [
    `/user/authenticated-status`
    ] as const;
    }


export const getCheckUserAuthStatusQueryOptions = <TData = Awaited<ReturnType<typeof checkUserAuthStatus>>, TError = InternalErrorResponse>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkUserAuthStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCheckUserAuthStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof checkUserAuthStatus>>> = ({ signal }) => checkUserAuthStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof checkUserAuthStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type CheckUserAuthStatusQueryResult = NonNullable<Awaited<ReturnType<typeof checkUserAuthStatus>>>
export type CheckUserAuthStatusQueryError = InternalErrorResponse



export function useCheckUserAuthStatus<TData = Awaited<ReturnType<typeof checkUserAuthStatus>>, TError = InternalErrorResponse>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof checkUserAuthStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getCheckUserAuthStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Start a session using ID token
 */
export const getLoginUserUrl = () => {




  return `/user/login`
}

export const loginUser = async (loginUserBody: LoginUserBody, options?: RequestInit) => {

  return customFetch<void>(getLoginUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      loginUserBody,)
  }
);}




export const getLoginUserMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: LoginUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: LoginUserBody}, TContext> => {

const mutationKey = ['loginUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginUser>>, {data: LoginUserBody}> = (props) => {
          const {data} = props ?? {};

          return  loginUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginUserMutationResult = NonNullable<Awaited<ReturnType<typeof loginUser>>>
    export type LoginUserMutationBody = LoginUserBody
    export type LoginUserMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useLoginUser = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginUser>>, TError,{data: LoginUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof loginUser>>,
        TError,
        {data: LoginUserBody},
        TContext
      > => {
      return useMutation(getLoginUserMutationOptions(options));
    }

/**
 * Logout a session
 */
export const getLogoutUserUrl = () => {




  return `/user/login`
}

export const logoutUser = async ( options?: RequestInit) => {

  return customFetch<void>(getLogoutUserUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getLogoutUserMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,void, TContext> => {

const mutationKey = ['logoutUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutUser>>, void> = () => {


          return  logoutUser(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutUserMutationResult = NonNullable<Awaited<ReturnType<typeof logoutUser>>>

    export type LogoutUserMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useLogoutUser = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof logoutUser>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutUserMutationOptions(options));
    }

/**
 * Start a CLI session and create a custom token
 */
export const getCreateUserTokenUrl = () => {




  return `/user/token`
}

export const createUserToken = async ( options?: RequestInit) => {

  return customFetch<CreateUserToken201>(getCreateUserTokenUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateUserTokenMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserToken>>, TError,void, TContext> => {

const mutationKey = ['createUserToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserToken>>, void> = () => {


          return  createUserToken(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserTokenMutationResult = NonNullable<Awaited<ReturnType<typeof createUserToken>>>

    export type CreateUserTokenMutationError = BadRequestResponse | RequiresAuthenticationResponse | InternalErrorResponse

    export const useCreateUserToken = <TError = BadRequestResponse | RequiresAuthenticationResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserToken>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createUserToken>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateUserTokenMutationOptions(options));
    }

/**
 * Verify a one time password for MFA
 */
export const getUserTOTPVerifyUrl = () => {




  return `/user/totp/verify`
}

export const userTOTPVerify = async (userTOTPVerifyBody: UserTOTPVerifyBody, options?: RequestInit) => {

  return customFetch<UserTOTPVerify201>(getUserTOTPVerifyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userTOTPVerifyBody,)
  }
);}




export const getUserTOTPVerifyMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userTOTPVerify>>, TError,{data: UserTOTPVerifyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userTOTPVerify>>, TError,{data: UserTOTPVerifyBody}, TContext> => {

const mutationKey = ['userTOTPVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userTOTPVerify>>, {data: UserTOTPVerifyBody}> = (props) => {
          const {data} = props ?? {};

          return  userTOTPVerify(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserTOTPVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof userTOTPVerify>>>
    export type UserTOTPVerifyMutationBody = UserTOTPVerifyBody
    export type UserTOTPVerifyMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useUserTOTPVerify = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | UnprocessableEntityResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userTOTPVerify>>, TError,{data: UserTOTPVerifyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof userTOTPVerify>>,
        TError,
        {data: UserTOTPVerifyBody},
        TContext
      > => {
      return useMutation(getUserTOTPVerifyMutationOptions(options));
    }

/**
 * Set up MFA for the current user
 */
export const getUserTOTPSetupUrl = () => {




  return `/user/totp`
}

export const userTOTPSetup = async ( options?: RequestInit) => {

  return customFetch<UserTOTPSetup200>(getUserTOTPSetupUrl(),
  {
    ...options,
    method: 'POST'


  }
);}




export const getUserTOTPSetupMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userTOTPSetup>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userTOTPSetup>>, TError,void, TContext> => {

const mutationKey = ['userTOTPSetup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userTOTPSetup>>, void> = () => {


          return  userTOTPSetup(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserTOTPSetupMutationResult = NonNullable<Awaited<ReturnType<typeof userTOTPSetup>>>

    export type UserTOTPSetupMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useUserTOTPSetup = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userTOTPSetup>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof userTOTPSetup>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUserTOTPSetupMutationOptions(options));
    }

/**
 * Disable MFA for the current user
 */
export const getUserTOTPDeleteUrl = () => {




  return `/user/totp`
}

export const userTOTPDelete = async ( options?: RequestInit) => {

  return customFetch<void>(getUserTOTPDeleteUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getUserTOTPDeleteMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userTOTPDelete>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof userTOTPDelete>>, TError,void, TContext> => {

const mutationKey = ['userTOTPDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userTOTPDelete>>, void> = () => {


          return  userTOTPDelete(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UserTOTPDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof userTOTPDelete>>>

    export type UserTOTPDeleteMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useUserTOTPDelete = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userTOTPDelete>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof userTOTPDelete>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUserTOTPDeleteMutationOptions(options));
    }

/**
 * Register new user
 */
export const getRegisterUserUrl = () => {




  return `/user/register`
}

export const registerUser = async (registerUserBody: RegisterUserBody, options?: RequestInit) => {

  return customFetch<RegisterUser201>(getRegisterUserUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerUserBody,)
  }
);}




export const getRegisterUserMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: RegisterUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: RegisterUserBody}, TContext> => {

const mutationKey = ['registerUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerUser>>, {data: RegisterUserBody}> = (props) => {
          const {data} = props ?? {};

          return  registerUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterUserMutationResult = NonNullable<Awaited<ReturnType<typeof registerUser>>>
    export type RegisterUserMutationBody = RegisterUserBody
    export type RegisterUserMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useRegisterUser = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerUser>>, TError,{data: RegisterUserBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof registerUser>>,
        TError,
        {data: RegisterUserBody},
        TContext
      > => {
      return useMutation(getRegisterUserMutationOptions(options));
    }

/**
 * Reset user password from email
 */
export const getResetUserPasswordUrl = () => {




  return `/user/reset-password`
}

export const resetUserPassword = async (resetUserPasswordBody: ResetUserPasswordBody, options?: RequestInit) => {

  return customFetch<void>(getResetUserPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resetUserPasswordBody,)
  }
);}




export const getResetUserPasswordMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: ResetUserPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: ResetUserPasswordBody}, TContext> => {

const mutationKey = ['resetUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetUserPassword>>, {data: ResetUserPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  resetUserPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetUserPassword>>>
    export type ResetUserPasswordMutationBody = ResetUserPasswordBody
    export type ResetUserPasswordMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useResetUserPassword = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetUserPassword>>, TError,{data: ResetUserPasswordBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resetUserPassword>>,
        TError,
        {data: ResetUserPasswordBody},
        TContext
      > => {
      return useMutation(getResetUserPasswordMutationOptions(options));
    }

/**
 * Verify user email
 */
export const getVerifyUserEmailUrl = () => {




  return `/user/verify-email`
}

export const verifyUserEmail = async (verifyUserEmailBody: VerifyUserEmailBody, options?: RequestInit) => {

  return customFetch<void>(getVerifyUserEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      verifyUserEmailBody,)
  }
);}




export const getVerifyUserEmailMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyUserEmail>>, TError,{data: VerifyUserEmailBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyUserEmail>>, TError,{data: VerifyUserEmailBody}, TContext> => {

const mutationKey = ['verifyUserEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyUserEmail>>, {data: VerifyUserEmailBody}> = (props) => {
          const {data} = props ?? {};

          return  verifyUserEmail(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type VerifyUserEmailMutationResult = NonNullable<Awaited<ReturnType<typeof verifyUserEmail>>>
    export type VerifyUserEmailMutationBody = VerifyUserEmailBody
    export type VerifyUserEmailMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useVerifyUserEmail = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyUserEmail>>, TError,{data: VerifyUserEmailBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof verifyUserEmail>>,
        TError,
        {data: VerifyUserEmailBody},
        TContext
      > => {
      return useMutation(getVerifyUserEmailMutationOptions(options));
    }

/**
 * List of the current user's unaccepted invitations
 */
export const getListCurrentUserInvitationsUrl = (params?: ListCurrentUserInvitationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/user/invitations?${stringifiedParams}` : `/user/invitations`
}

export const listCurrentUserInvitations = async (params?: ListCurrentUserInvitationsParams, options?: RequestInit) => {

  return customFetch<ListCurrentUserInvitations200>(getListCurrentUserInvitationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCurrentUserInvitationsQueryKey = (params?: ListCurrentUserInvitationsParams,) => {
    return [
    `/user/invitations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCurrentUserInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError = InternalErrorResponse>(params?: ListCurrentUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCurrentUserInvitationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrentUserInvitations>>> = ({ signal }) => listCurrentUserInvitations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCurrentUserInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrentUserInvitations>>>
export type ListCurrentUserInvitationsQueryError = InternalErrorResponse



export function useListCurrentUserInvitations<TData = Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError = InternalErrorResponse>(
 params?: ListCurrentUserInvitationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCurrentUserInvitations>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCurrentUserInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get memberships that the user has accepted.
 */
export const getGetCurrentUserMembershipsUrl = (params?: GetCurrentUserMembershipsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/user/memberships?${stringifiedParams}` : `/user/memberships`
}

export const getCurrentUserMemberships = async (params?: GetCurrentUserMembershipsParams, options?: RequestInit) => {

  return customFetch<GetCurrentUserMemberships200>(getGetCurrentUserMembershipsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCurrentUserMembershipsQueryKey = (params?: GetCurrentUserMembershipsParams,) => {
    return [
    `/user/memberships`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCurrentUserMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse>(params?: GetCurrentUserMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentUserMembershipsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserMemberships>>> = ({ signal }) => getCurrentUserMemberships(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCurrentUserMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentUserMemberships>>>
export type GetCurrentUserMembershipsQueryError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse



export function useGetCurrentUserMemberships<TData = Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError = RequiresAuthenticationResponse | ForbiddenResponse | InternalErrorResponse>(
 params?: GetCurrentUserMembershipsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserMemberships>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCurrentUserMembershipsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Send a user event
 */
export const getSendUserEventUrl = () => {




  return `/user/event`
}

export const sendUserEvent = async (sendUserEventBody: SendUserEventBody, options?: RequestInit) => {

  return customFetch<void>(getSendUserEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendUserEventBody,)
  }
);}




export const getSendUserEventMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendUserEvent>>, TError,{data: SendUserEventBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendUserEvent>>, TError,{data: SendUserEventBody}, TContext> => {

const mutationKey = ['sendUserEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendUserEvent>>, {data: SendUserEventBody}> = (props) => {
          const {data} = props ?? {};

          return  sendUserEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendUserEventMutationResult = NonNullable<Awaited<ReturnType<typeof sendUserEvent>>>
    export type SendUserEventMutationBody = SendUserEventBody
    export type SendUserEventMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useSendUserEvent = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendUserEvent>>, TError,{data: SendUserEventBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendUserEvent>>,
        TError,
        {data: SendUserEventBody},
        TContext
      > => {
      return useMutation(getSendUserEventMutationOptions(options));
    }

/**
 * Send an anonymous event
 */
export const getSendAnonymousEventUrl = () => {




  return `/user/anon-event`
}

export const sendAnonymousEvent = async (sendAnonymousEventBody: SendAnonymousEventBody, options?: RequestInit) => {

  return customFetch<void>(getSendAnonymousEventUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendAnonymousEventBody,)
  }
);}




export const getSendAnonymousEventMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnonymousEvent>>, TError,{data: SendAnonymousEventBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendAnonymousEvent>>, TError,{data: SendAnonymousEventBody}, TContext> => {

const mutationKey = ['sendAnonymousEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAnonymousEvent>>, {data: SendAnonymousEventBody}> = (props) => {
          const {data} = props ?? {};

          return  sendAnonymousEvent(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendAnonymousEventMutationResult = NonNullable<Awaited<ReturnType<typeof sendAnonymousEvent>>>
    export type SendAnonymousEventMutationBody = SendAnonymousEventBody
    export type SendAnonymousEventMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useSendAnonymousEvent = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnonymousEvent>>, TError,{data: SendAnonymousEventBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof sendAnonymousEvent>>,
        TError,
        {data: SendAnonymousEventBody},
        TContext
      > => {
      return useMutation(getSendAnonymousEventMutationOptions(options));
    }

/**
 * Update customer details
 */
export const getUpdateCustomerUrl = () => {




  return `/user/customer`
}

export const updateCustomer = async (updateCustomerBody: UpdateCustomerBody, options?: RequestInit) => {

  return customFetch<void>(getUpdateCustomerUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateCustomerBody,)
  }
);}




export const getUpdateCustomerMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{data: UpdateCustomerBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{data: UpdateCustomerBody}, TContext> => {

const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {data: UpdateCustomerBody}> = (props) => {
          const {data} = props ?? {};

          return  updateCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = UpdateCustomerBody
    export type UpdateCustomerMutationError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse

    export const useUpdateCustomer = <TError = BadRequestResponse | RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{data: UpdateCustomerBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {data: UpdateCustomerBody},
        TContext
      > => {
      return useMutation(getUpdateCustomerMutationOptions(options));
    }

/**
 * Determine platform tenant by email
 */
export const getDeterminePlatformTenantByEmailUrl = (params: DeterminePlatformTenantByEmailParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/user/tenant?${stringifiedParams}` : `/user/tenant`
}

export const determinePlatformTenantByEmail = async (params: DeterminePlatformTenantByEmailParams, options?: RequestInit) => {

  return customFetch<DeterminePlatformTenantByEmail200>(getDeterminePlatformTenantByEmailUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getDeterminePlatformTenantByEmailQueryKey = (params?: DeterminePlatformTenantByEmailParams,) => {
    return [
    `/user/tenant`, ...(params ? [params] : [])
    ] as const;
    }


export const getDeterminePlatformTenantByEmailQueryOptions = <TData = Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(params: DeterminePlatformTenantByEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDeterminePlatformTenantByEmailQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>> = ({ signal }) => determinePlatformTenantByEmail(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError, TData> & { queryKey: QueryKey }
}

export type DeterminePlatformTenantByEmailQueryResult = NonNullable<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>>
export type DeterminePlatformTenantByEmailQueryError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse



export function useDeterminePlatformTenantByEmail<TData = Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse>(
 params: DeterminePlatformTenantByEmailParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof determinePlatformTenantByEmail>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getDeterminePlatformTenantByEmailQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Delete user
 */
export const getDeleteUserUrl = (userId: string,) => {




  return `/users/${userId}`
}

export const deleteUser = async (userId: string, options?: RequestInit) => {

  return customFetch<void>(getDeleteUserUrl(userId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteUserMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  deleteUser(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>

    export type DeleteUserMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteUser = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getDeleteUserMutationOptions(options));
    }

/**
 * List all team API Keys
 */
export const getListTeamAPIKeysUrl = (teamName: string,
    params?: ListTeamAPIKeysParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/apikeys?${stringifiedParams}` : `/teams/${teamName}/apikeys`
}

export const listTeamAPIKeys = async (teamName: string,
    params?: ListTeamAPIKeysParams, options?: RequestInit) => {

  return customFetch<ListTeamAPIKeys200>(getListTeamAPIKeysUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTeamAPIKeysQueryKey = (teamName: string,
    params?: ListTeamAPIKeysParams,) => {
    return [
    `/teams/${teamName}/apikeys`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTeamAPIKeysQueryOptions = <TData = Awaited<ReturnType<typeof listTeamAPIKeys>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: ListTeamAPIKeysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamAPIKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTeamAPIKeysQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeamAPIKeys>>> = ({ signal }) => listTeamAPIKeys(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeamAPIKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTeamAPIKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listTeamAPIKeys>>>
export type ListTeamAPIKeysQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useListTeamAPIKeys<TData = Awaited<ReturnType<typeof listTeamAPIKeys>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: ListTeamAPIKeysParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTeamAPIKeys>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTeamAPIKeysQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create new team API Key.
 */
export const getCreateTeamAPIKeyUrl = (teamName: string,) => {




  return `/teams/${teamName}/apikeys`
}

export const createTeamAPIKey = async (teamName: string,
    createTeamAPIKeyBody: CreateTeamAPIKeyBody, options?: RequestInit) => {

  return customFetch<APIKey>(getCreateTeamAPIKeyUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTeamAPIKeyBody,)
  }
);}




export const getCreateTeamAPIKeyMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamAPIKey>>, TError,{teamName: string;data: CreateTeamAPIKeyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTeamAPIKey>>, TError,{teamName: string;data: CreateTeamAPIKeyBody}, TContext> => {

const mutationKey = ['createTeamAPIKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTeamAPIKey>>, {teamName: string;data: CreateTeamAPIKeyBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createTeamAPIKey(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTeamAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createTeamAPIKey>>>
    export type CreateTeamAPIKeyMutationBody = CreateTeamAPIKeyBody
    export type CreateTeamAPIKeyMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateTeamAPIKey = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTeamAPIKey>>, TError,{teamName: string;data: CreateTeamAPIKeyBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTeamAPIKey>>,
        TError,
        {teamName: string;data: CreateTeamAPIKeyBody},
        TContext
      > => {
      return useMutation(getCreateTeamAPIKeyMutationOptions(options));
    }

/**
 * Delete API Key. This will remove any future access by this API Key.
 */
export const getDeleteTeamAPIKeyUrl = (teamName: string,
    apikeyId: string,) => {




  return `/teams/${teamName}/apikeys/${apikeyId}`
}

export const deleteTeamAPIKey = async (teamName: string,
    apikeyId: string, options?: RequestInit) => {

  return customFetch<void>(getDeleteTeamAPIKeyUrl(teamName,apikeyId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTeamAPIKeyMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext> => {

const mutationKey = ['deleteTeamAPIKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTeamAPIKey>>, {teamName: string;apikeyId: string}> = (props) => {
          const {teamName,apikeyId} = props ?? {};

          return  deleteTeamAPIKey(teamName,apikeyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTeamAPIKeyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTeamAPIKey>>>

    export type DeleteTeamAPIKeyMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse

    export const useDeleteTeamAPIKey = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTeamAPIKey>>, TError,{teamName: string;apikeyId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTeamAPIKey>>,
        TError,
        {teamName: string;apikeyId: string},
        TContext
      > => {
      return useMutation(getDeleteTeamAPIKeyMutationOptions(options));
    }

/**
 * Performs authentication and authorization for our image registry.
 */
export const getAuthRegistryRequestUrl = (params?: AuthRegistryRequestParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/registry/auth?${stringifiedParams}` : `/registry/auth`
}

export const authRegistryRequest = async (params?: AuthRegistryRequestParams, options?: RequestInit) => {

  return customFetch<RegistryAuthToken>(getAuthRegistryRequestUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuthRegistryRequestQueryKey = (params?: AuthRegistryRequestParams,) => {
    return [
    `/registry/auth`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuthRegistryRequestQueryOptions = <TData = Awaited<ReturnType<typeof authRegistryRequest>>, TError = DockerErrorResponse>(params?: AuthRegistryRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authRegistryRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthRegistryRequestQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authRegistryRequest>>> = ({ signal }) => authRegistryRequest(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authRegistryRequest>>, TError, TData> & { queryKey: QueryKey }
}

export type AuthRegistryRequestQueryResult = NonNullable<Awaited<ReturnType<typeof authRegistryRequest>>>
export type AuthRegistryRequestQueryError = DockerErrorResponse



export function useAuthRegistryRequest<TData = Awaited<ReturnType<typeof authRegistryRequest>>, TError = DockerErrorResponse>(
 params?: AuthRegistryRequestParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof authRegistryRequest>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getAuthRegistryRequestQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Get a paginated list of managed databases
 */
export const getGetManagedDatabasesUrl = (teamName: string,
    params?: GetManagedDatabasesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/teams/${teamName}/managed-databases?${stringifiedParams}` : `/teams/${teamName}/managed-databases`
}

export const getManagedDatabases = async (teamName: string,
    params?: GetManagedDatabasesParams, options?: RequestInit) => {

  return customFetch<GetManagedDatabases200>(getGetManagedDatabasesUrl(teamName,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManagedDatabasesQueryKey = (teamName: string,
    params?: GetManagedDatabasesParams,) => {
    return [
    `/teams/${teamName}/managed-databases`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetManagedDatabasesQueryOptions = <TData = Awaited<ReturnType<typeof getManagedDatabases>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    params?: GetManagedDatabasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManagedDatabasesQueryKey(teamName,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManagedDatabases>>> = ({ signal }) => getManagedDatabases(teamName,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabases>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManagedDatabasesQueryResult = NonNullable<Awaited<ReturnType<typeof getManagedDatabases>>>
export type GetManagedDatabasesQueryError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse



export function useGetManagedDatabases<TData = Awaited<ReturnType<typeof getManagedDatabases>>, TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    params?: GetManagedDatabasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabases>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetManagedDatabasesQueryOptions(teamName,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Create a new managed database
 */
export const getCreateManagedDatabaseUrl = (teamName: string,) => {




  return `/teams/${teamName}/managed-databases`
}

export const createManagedDatabase = async (teamName: string,
    managedDatabaseCreate: ManagedDatabaseCreate, options?: RequestInit) => {

  return customFetch<ManagedDatabase>(getCreateManagedDatabaseUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      managedDatabaseCreate,)
  }
);}




export const getCreateManagedDatabaseMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createManagedDatabase>>, TError,{teamName: string;data: ManagedDatabaseCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createManagedDatabase>>, TError,{teamName: string;data: ManagedDatabaseCreate}, TContext> => {

const mutationKey = ['createManagedDatabase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createManagedDatabase>>, {teamName: string;data: ManagedDatabaseCreate}> = (props) => {
          const {teamName,data} = props ?? {};

          return  createManagedDatabase(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateManagedDatabaseMutationResult = NonNullable<Awaited<ReturnType<typeof createManagedDatabase>>>
    export type CreateManagedDatabaseMutationBody = ManagedDatabaseCreate
    export type CreateManagedDatabaseMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useCreateManagedDatabase = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | ConflictResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createManagedDatabase>>, TError,{teamName: string;data: ManagedDatabaseCreate}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createManagedDatabase>>,
        TError,
        {teamName: string;data: ManagedDatabaseCreate},
        TContext
      > => {
      return useMutation(getCreateManagedDatabaseMutationOptions(options));
    }

/**
 * Get a single managed database.
 */
export const getGetManagedDatabaseUrl = (teamName: string,
    managedDatabaseId: string,) => {




  return `/teams/${teamName}/managed-databases/${managedDatabaseId}`
}

export const getManagedDatabase = async (teamName: string,
    managedDatabaseId: string, options?: RequestInit) => {

  return customFetch<ManagedDatabase>(getGetManagedDatabaseUrl(teamName,managedDatabaseId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetManagedDatabaseQueryKey = (teamName: string,
    managedDatabaseId: string,) => {
    return [
    `/teams/${teamName}/managed-databases/${managedDatabaseId}`
    ] as const;
    }


export const getGetManagedDatabaseQueryOptions = <TData = Awaited<ReturnType<typeof getManagedDatabase>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(teamName: string,
    managedDatabaseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabase>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetManagedDatabaseQueryKey(teamName,managedDatabaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getManagedDatabase>>> = ({ signal }) => getManagedDatabase(teamName,managedDatabaseId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(teamName && managedDatabaseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabase>>, TError, TData> & { queryKey: QueryKey }
}

export type GetManagedDatabaseQueryResult = NonNullable<Awaited<ReturnType<typeof getManagedDatabase>>>
export type GetManagedDatabaseQueryError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse



export function useGetManagedDatabase<TData = Awaited<ReturnType<typeof getManagedDatabase>>, TError = RequiresAuthenticationResponse | NotFoundResponse | InternalErrorResponse>(
 teamName: string,
    managedDatabaseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getManagedDatabase>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetManagedDatabaseQueryOptions(teamName,managedDatabaseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * Delete this managed database. Any syncs relying on this database must be deleted first.
 */
export const getDeleteManagedDatabaseUrl = (teamName: string,
    managedDatabaseId: string,) => {




  return `/teams/${teamName}/managed-databases/${managedDatabaseId}`
}

export const deleteManagedDatabase = async (teamName: string,
    managedDatabaseId: string, options?: RequestInit) => {

  return customFetch<void>(getDeleteManagedDatabaseUrl(teamName,managedDatabaseId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteManagedDatabaseMutationOptions = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteManagedDatabase>>, TError,{teamName: string;managedDatabaseId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteManagedDatabase>>, TError,{teamName: string;managedDatabaseId: string}, TContext> => {

const mutationKey = ['deleteManagedDatabase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteManagedDatabase>>, {teamName: string;managedDatabaseId: string}> = (props) => {
          const {teamName,managedDatabaseId} = props ?? {};

          return  deleteManagedDatabase(teamName,managedDatabaseId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteManagedDatabaseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteManagedDatabase>>>

    export type DeleteManagedDatabaseMutationError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse

    export const useDeleteManagedDatabase = <TError = RequiresAuthenticationResponse | NotFoundResponse | UnprocessableEntityResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteManagedDatabase>>, TError,{teamName: string;managedDatabaseId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteManagedDatabase>>,
        TError,
        {teamName: string;managedDatabaseId: string},
        TContext
      > => {
      return useMutation(getDeleteManagedDatabaseMutationOptions(options));
    }

/**
 * Activate platform usage by API key
 */
export const getActivatePlatformUrl = () => {




  return `/platform/activate`
}

export const activatePlatform = async (activatePlatformBody: ActivatePlatformBody, options?: RequestInit) => {

  return customFetch<ActivatePlatform200 | ActivatePlatform205>(getActivatePlatformUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      activatePlatformBody,)
  }
);}




export const getActivatePlatformMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePlatform>>, TError,{data: ActivatePlatformBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof activatePlatform>>, TError,{data: ActivatePlatformBody}, TContext> => {

const mutationKey = ['activatePlatform'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activatePlatform>>, {data: ActivatePlatformBody}> = (props) => {
          const {data} = props ?? {};

          return  activatePlatform(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ActivatePlatformMutationResult = NonNullable<Awaited<ReturnType<typeof activatePlatform>>>
    export type ActivatePlatformMutationBody = ActivatePlatformBody
    export type ActivatePlatformMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useActivatePlatform = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePlatform>>, TError,{data: ActivatePlatformBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof activatePlatform>>,
        TError,
        {data: ActivatePlatformBody},
        TContext
      > => {
      return useMutation(getActivatePlatformMutationOptions(options));
    }

/**
 * Renew platform activation
 */
export const getRenewPlatformActivationUrl = () => {




  return `/platform/activate/renew`
}

export const renewPlatformActivation = async (renewPlatformActivationBody: RenewPlatformActivationBody, options?: RequestInit) => {

  return customFetch<RenewPlatformActivation200 | RenewPlatformActivation205>(getRenewPlatformActivationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      renewPlatformActivationBody,)
  }
);}




export const getRenewPlatformActivationMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewPlatformActivation>>, TError,{data: RenewPlatformActivationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof renewPlatformActivation>>, TError,{data: RenewPlatformActivationBody}, TContext> => {

const mutationKey = ['renewPlatformActivation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renewPlatformActivation>>, {data: RenewPlatformActivationBody}> = (props) => {
          const {data} = props ?? {};

          return  renewPlatformActivation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenewPlatformActivationMutationResult = NonNullable<Awaited<ReturnType<typeof renewPlatformActivation>>>
    export type RenewPlatformActivationMutationBody = RenewPlatformActivationBody
    export type RenewPlatformActivationMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useRenewPlatformActivation = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renewPlatformActivation>>, TError,{data: RenewPlatformActivationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof renewPlatformActivation>>,
        TError,
        {data: RenewPlatformActivationBody},
        TContext
      > => {
      return useMutation(getRenewPlatformActivationMutationOptions(options));
    }

/**
 * Report platform data
 */
export const getReportPlatformDataUrl = () => {




  return `/platform/report`
}

export const reportPlatformData = async (reportPlatformDataBody: ReportPlatformDataBody, options?: RequestInit) => {

  return customFetch<void>(getReportPlatformDataUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reportPlatformDataBody,)
  }
);}




export const getReportPlatformDataMutationOptions = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportPlatformData>>, TError,{data: ReportPlatformDataBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reportPlatformData>>, TError,{data: ReportPlatformDataBody}, TContext> => {

const mutationKey = ['reportPlatformData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportPlatformData>>, {data: ReportPlatformDataBody}> = (props) => {
          const {data} = props ?? {};

          return  reportPlatformData(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportPlatformDataMutationResult = NonNullable<Awaited<ReturnType<typeof reportPlatformData>>>
    export type ReportPlatformDataMutationBody = ReportPlatformDataBody
    export type ReportPlatformDataMutationError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useReportPlatformData = <TError = BadRequestResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportPlatformData>>, TError,{data: ReportPlatformDataBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reportPlatformData>>,
        TError,
        {data: ReportPlatformDataBody},
        TContext
      > => {
      return useMutation(getReportPlatformDataMutationOptions(options));
    }

/**
 * Report tenant platform data
 */
export const getReportTenantPlatformDataUrl = (tenantId: string,) => {




  return `/platform/${tenantId}/report`
}

export const reportTenantPlatformData = async (tenantId: string,
    reportTenantPlatformDataBody: ReportTenantPlatformDataBody, options?: RequestInit) => {

  return customFetch<void>(getReportTenantPlatformDataUrl(tenantId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reportTenantPlatformDataBody,)
  }
);}




export const getReportTenantPlatformDataMutationOptions = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportTenantPlatformData>>, TError,{tenantId: string;data: ReportTenantPlatformDataBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reportTenantPlatformData>>, TError,{tenantId: string;data: ReportTenantPlatformDataBody}, TContext> => {

const mutationKey = ['reportTenantPlatformData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportTenantPlatformData>>, {tenantId: string;data: ReportTenantPlatformDataBody}> = (props) => {
          const {tenantId,data} = props ?? {};

          return  reportTenantPlatformData(tenantId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportTenantPlatformDataMutationResult = NonNullable<Awaited<ReturnType<typeof reportTenantPlatformData>>>
    export type ReportTenantPlatformDataMutationBody = ReportTenantPlatformDataBody
    export type ReportTenantPlatformDataMutationError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse

    export const useReportTenantPlatformData = <TError = BadRequestResponse | ForbiddenResponse | NotFoundResponse | TooManyRequestsResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportTenantPlatformData>>, TError,{tenantId: string;data: ReportTenantPlatformDataBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reportTenantPlatformData>>,
        TError,
        {tenantId: string;data: ReportTenantPlatformDataBody},
        TContext
      > => {
      return useMutation(getReportTenantPlatformDataMutationOptions(options));
    }

/**
 * Send a chat message to the AI onboarding assistant
 */
export const getAIOnboardingChatUrl = (teamName: string,) => {




  return `/teams/${teamName}/ai-onboarding/chat`
}

export const aIOnboardingChat = async (teamName: string,
    aIOnboardingChatBody: AIOnboardingChatBody, options?: RequestInit) => {

  return customFetch<AIOnboardingChat200>(getAIOnboardingChatUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aIOnboardingChatBody,)
  }
);}




export const getAIOnboardingChatMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingChat>>, TError,{teamName: string;data: AIOnboardingChatBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingChat>>, TError,{teamName: string;data: AIOnboardingChatBody}, TContext> => {

const mutationKey = ['aIOnboardingChat'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aIOnboardingChat>>, {teamName: string;data: AIOnboardingChatBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  aIOnboardingChat(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AIOnboardingChatMutationResult = NonNullable<Awaited<ReturnType<typeof aIOnboardingChat>>>
    export type AIOnboardingChatMutationBody = AIOnboardingChatBody
    export type AIOnboardingChatMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useAIOnboardingChat = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingChat>>, TError,{teamName: string;data: AIOnboardingChatBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof aIOnboardingChat>>,
        TError,
        {teamName: string;data: AIOnboardingChatBody},
        TContext
      > => {
      return useMutation(getAIOnboardingChatMutationOptions(options));
    }

/**
 * Start a new conversation with the AI onboarding assistant
 */
export const getAIOnboardingNewConversationUrl = (teamName: string,) => {




  return `/teams/${teamName}/ai-onboarding/conversations`
}

export const aIOnboardingNewConversation = async (teamName: string,
    aIOnboardingNewConversationBody: AIOnboardingNewConversationBody, options?: RequestInit) => {

  return customFetch<AIOnboardingNewConversation200>(getAIOnboardingNewConversationUrl(teamName),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aIOnboardingNewConversationBody,)
  }
);}




export const getAIOnboardingNewConversationMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingNewConversation>>, TError,{teamName: string;data: AIOnboardingNewConversationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingNewConversation>>, TError,{teamName: string;data: AIOnboardingNewConversationBody}, TContext> => {

const mutationKey = ['aIOnboardingNewConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aIOnboardingNewConversation>>, {teamName: string;data: AIOnboardingNewConversationBody}> = (props) => {
          const {teamName,data} = props ?? {};

          return  aIOnboardingNewConversation(teamName,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AIOnboardingNewConversationMutationResult = NonNullable<Awaited<ReturnType<typeof aIOnboardingNewConversation>>>
    export type AIOnboardingNewConversationMutationBody = AIOnboardingNewConversationBody
    export type AIOnboardingNewConversationMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useAIOnboardingNewConversation = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingNewConversation>>, TError,{teamName: string;data: AIOnboardingNewConversationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof aIOnboardingNewConversation>>,
        TError,
        {teamName: string;data: AIOnboardingNewConversationBody},
        TContext
      > => {
      return useMutation(getAIOnboardingNewConversationMutationOptions(options));
    }

/**
 * End the current AI onboarding conversation
 */
export const getAIOnboardingEndConversationUrl = (teamName: string,) => {




  return `/teams/${teamName}/ai-onboarding/conversations`
}

export const aIOnboardingEndConversation = async (teamName: string, options?: RequestInit) => {

  return customFetch<AIOnboardingEndConversation200>(getAIOnboardingEndConversationUrl(teamName),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getAIOnboardingEndConversationMutationOptions = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingEndConversation>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingEndConversation>>, TError,{teamName: string}, TContext> => {

const mutationKey = ['aIOnboardingEndConversation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof aIOnboardingEndConversation>>, {teamName: string}> = (props) => {
          const {teamName} = props ?? {};

          return  aIOnboardingEndConversation(teamName,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AIOnboardingEndConversationMutationResult = NonNullable<Awaited<ReturnType<typeof aIOnboardingEndConversation>>>

    export type AIOnboardingEndConversationMutationError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse

    export const useAIOnboardingEndConversation = <TError = BadRequestResponse | RequiresAuthenticationResponse | ForbiddenResponse | NotFoundResponse | MethodNotAllowedResponse | InternalErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof aIOnboardingEndConversation>>, TError,{teamName: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof aIOnboardingEndConversation>>,
        TError,
        {teamName: string},
        TContext
      > => {
      return useMutation(getAIOnboardingEndConversationMutationOptions(options));
    }
